const transactionTopics = [
  {
    type: "transaction topic",
    id: "vacantLand",
    title: "Vacant Land (Residential Use)",
    description: `<p>
    Vacant land refers to property that is not currently in use for any specific 
    purpose. Its value and potential depend on various factors, including location, 
    zoning regulations, and land type. The advice provided assumes your client 
    has found a piece of land that appeals to them.
    <br/>
    <br/>
    Proper due diligence is crucial when helping a client purchase vacant land. 
    It ensures the property meets their intended use and protects them from legal, 
    zoning, or environmental issues—allowing for informed, confident decisions.
    <br/>
    <br/>
    This is a general approach to this type of transaction based on a multitude of 
    varying common circumstances. Location can play a large factor in how much due 
    diligence is required since items like road access and connection to services can 
    be much easier to verify in certain situations. Each deal is unique, so the 
    responsibility is on the eXp Realty REALTOR® to perform proper due diligence as 
    part of their legal obligation to provide competent service.
    </p>`,
    text: [
      {
        title: `Common Types Of Land`,
        text: `
    <strong>Raw Land</strong><br/> 
    Land that has never been developed and therefore has no existing structures or 
    utilities like electricity or water.<br/><br/>
    <strong>Vacant Land</strong><br/>
    Like raw land, vacant land is also privately owned. However, unlike raw land, 
    it is serviced or partially serviced. This means that it may have utilities like 
    electricity, water, and septic, and could have pre-existing developments but no 
    permanent structures.<br/><br/> 

    <strong>Crown Land</strong><br/>
    Crown land is public land that is owned by the provincial government of Ontario. 
    The majority of land in the province (87%, to be exact) is Crown land. Most Crown 
    land is in the northern part of the province, whereas 
    the southern part of Ontario is largely privately owned. There are several 
    restrictions and conditions relating to the use of Crown land, whether this use 
    is residential (home) or recreational (cottage). This type of land is typically 
    sold at market value. You will only be able to buy crown land within the bounds 
    of an existing municipality.<br/>
   `,
      },
      {
        title: `What To Consider When Buying Land`,
        text: `
    <strong>Zoning</strong><br/>
    Zoning requirements outline parameters like the types of structures that can be 
    built on it,  maximum building height, lot coverage, and required distance from 
    the sidewalk. They can also sometimes include restrictions on renovations or 
    additions like garages, pools, or decks. Most areas have requirements regarding 
    minimum square footage, the minimum size of a buildable lot, and what kinds of 
    housing can be added to different properties. <br/>
    <strong class="bold">Action:</strong> Confirm Zoning in GeoWarehouse. Contact the 
    local municipality's zoning department to confirm the property's zoning, permitted 
    uses, and any applicable restrictions.<br/><br/>
    <strong>Survey</strong><br/>
    Land surveys are critical for land Buyers. The purpose is to determine the 
    property's legal boundaries and easements. Unless the survey was done within the last 
    year or two, it is essential that you conduct a survey.
    <br/> 
    <strong class="bold">Action:</strong> Confirm if the current owner has a recent 
    land survey. Alternatively, you can connect with the local land registry office 
    to see if they have a copy of the survey or look into having a Licensed Ontario 
    Land Surveyor conduct a survey.<br/>
 
    <br/><strong>Soil test/Percolation test</strong><br/>
     Typically what is needed is a geotechnical 
    investigation. This test helps determine the soil's composition, strength, 
    and stability, which is crucial for designing a safe and structurally sound 
    building foundation. Additionally, a percolation test is essential if 
    the land lacks access to public sewer systems, as it assesses the soil's 
    ability to absorb wastewater for a septic system. Sandy soil, although 
    great for drainage, may require the use of double footings. In many 
    situations, these tests will be a prerequisite for obtaining a building permit.
    <br/> 
    <strong class="bold">Action:</strong> Contact your local municipality to 
    determine whether this test is required for obtaining a building permit. 
    Regardless of the requirement, it is strongly recommended to confirm that the 
    land is suitable for your client's intended use. You may also want to ask the 
    municipality or colleagues if they have a list of approved geotechnical 
    engineers in the area.
    <br/>

    <br/><strong>HST Implications</strong><br/>
     Typically HST does not apply  to the sale of vacant land if it's considered a 
     resale of real property. Depending on the history of the property HST may 
     apply and so it's important to assess each situation to be sure.
    <br/> 
    <strong class="bold">Action:</strong> Have your client reach out to their 
    lawyer or accountant to determine if there are any HST implications with the 
    purchase of the property.
    <br/>

    <br/><strong>Internet/Telecommunications Services</strong><br/>
    Access to high-speed internet and reliable telecommunications is becoming more 
    essential for clients—not just for entertainment, but also due to the growing 
    need for remote work and smart home connectivity.<br/>
    <strong class="bold">Action:</strong> Connect with local service providers to 
    ensure access to high-speed internet and reliable telecommunications are 
    available.
    <br/>
    
    <br/><strong>Finding a Suitable Builder</strong><br/>
    Finding a suitable builder will be paramount to the success of building a 
    property that suits your client's needs. Ensure that you do thorough research 
    on the builder's reputation, experience, and the quality of their work. It is 
    also critical to ensure that the builder is registered with Tarion as Ontario 
    requires new home builders to provide warranty coverage. 
    <br/>
    <strong class="bold">Action:</strong> Search local building associations for 
    a list of builders in the area. Consult with other professionals in the area 
    to get recommendations. Ask for references and check their previous work. 
    Additionally, you can check the builder's website for their portfolio and 
    reviews. Connect your clients with multiple builders so that they can build 
    a relationship with the builder that is most suitable for their needs.
    <br/>

    <br/><strong>Subdivider's Agreement</strong><br/>
    Land in subdivisions often come with a subdivider's agreement, also known as 
    restrictive covenants. Restrictive Covenants are often created by developers 
    and municipalities and can restrict how land can be used. Some examples include: 
    restriction of fences, height of buildings, installation of pools, etc.
    <br/>
    <strong class="bold">Action:</strong> Contact your local municipality to obtain 
    a copy of the subdivider's agreement to assess the terms of the agreement and 
    determine if there are any restrictions on the property. Restrictive Covenants 
    can also be located in the Title Report obtained from GeoWarehouse. Have your 
    client's lawyer review for the presence of Restrictive Covenants.
    <br/>

    <br/><strong>Local Services</strong><br/>
    Schools, Hospitals, Shopping...etc<br/>
    <strong class="bold">Action:</strong> Discuss with your clients to confirm that 
    all essential services are accessible within a reasonable distance, as this 
    will significantly enhance their experience with the property.
    <br/>

    <br/><strong>Power</strong><br/>
    If a parcel does not have water or electricity, it may be necessary to have 
    those services run out to the property. Often, adding these utilities can mean 
    adding tens of thousands of dollars to the cost of building a home.
    If remote, will the law in the area allow for off-grid power sources 
    (ie. solar).<br/>
    <strong class="bold">Action:</strong> Check for existing services by asking the
    Seller/Agent. Verify with the local power provider to verify the information 
    provided. If power is not available, consult with a local power provider to 
    determine the cost of running power to the property.
    <br/>

    <br/><strong>Water well</strong><br/>
    If you're buying vacant land in Ontario that has a well, you will want to 
    conduct a well flow rate test and water quality test. If no well currently 
    exists, you will need to dig a well. Additionally, if there is a shared well,
    between multiple properties, obtaining the agreement would be important.
    <br/>
    <strong class="bold">Action:</strong> If a well needs to be dug, start by 
    consulting a local well contractor to assess the cost, feasibility, and the 
    type of well that can be installed on the property. For testing the water 
    quality of an existing well, you can usually contact your local health 
    department to obtain a water quality test kit. If there is a shared well,
    you will need to obtain the agreement from the other property owners to 
    determine the terms of the shared well agreement.
    <br/>

    <br/><strong>Gas Service</strong><br/>
     Depending on the property's location, it's important to evaluate the different 
     gas service options available, with natural gas and propane being the most 
     common choices. These decisions will influence multiple elements of the home, 
     such as the selection of the furnace, water heater, fireplace, and kitchen 
     appliances.
     <br/>
    <strong class="bold">Action:</strong> Begin by contacting the local utility 
    provider—typically Enbridge Gas in Ontario—to determine if natural gas service 
    is available at or near the property. Provide the property's municipal address 
    and request a service availability check or connection quote. If gas is not readily 
    available, inquire about the cost and feasibility of extending service. It's also 
    advisable to explore alternative options like propane if natural gas is not 
    accessible or cost-effective.
    <br/>
    

    <br/><strong>Septic Systems</strong><br/>
    The property may have to rely on a septic system if it's not connected to 
    municipal sewer lines. Check the land has enough room for an adequate septic 
    system. Appropriate sizing is determined by the size of the house you've planned, 
    the number of bedrooms, number of plumbing fixtures, soil type, and the type of 
    septic system.<br/>
    <strong class="bold">Action:</strong> Verify with the local municipality to 
    determine if a septic system is allowed on the property. If so, consult with 
    a local septic contractor to determine the cost of installing a septic system. 
    The septic system will need to be approved by the local municipality. The size 
    of the septic system will depend on the size of the house you've planned, the 
    number of bedrooms, number of plumbing fixtures, soil type, and the type of 
    septic system.
    <br/>

    

    <br/><strong>Access to Roadway</strong><br/>
    Road access is important for the property's accessibility and value as well 
    as enjoyment of the property. Some rural roads may have limited right of use 
    or are not maintained in the winter. Some properties have private roads with 
    associated rights of use and maintenance agreements.<br/>
    <strong class="bold">Action:</strong> Have the lawyer review the property's 
    title and any associated rights of use and maintenance agreements, if they exist.
    Contact the local municipality to determine if the road is maintained in the 
    winter as well as determining if the road is public or private.    
    <br/>

    <br/><strong>Environmental Protections</strong><br/>
    The local Conservation Authority to make sure your lot is not environmentally 
    protected. It's important to have an assessment done to ensure potential minimum 
    setbacks or no-disturb zones around wetlands, floodplains, or rivers. This way 
    you can have clear direction on where development can and cannot occur on the lot. 
    In some cases, the water table may be too high and it will not be feasible to build
    a home on the property.
    <br/>
    <strong class="bold">Action:</strong> Contact your local Conservation Authority 
    to determine if the property is environmentally protected and if development can 
    occur on the property. Additional permits may be required if the property falls 
    within the boundaries of a protected area.
    <br/>

    <br/><strong>Types of Potential Financing:</strong><br/>
    Land Mortgage: similar to a residential mortgage, except you will need to put 
    down a more significant down payment and pay higher interest rates.<br/>
    Construction Mortgage: type of loan utilized to acquire vacant land so you can 
    build on top.
    <br/>
    Lenders typically offer loans with higher interest rates. Your clients may also be 
    required to make a much larger down payment.<br/>
    <strong class="bold">Action:</strong> Connect your clients with a lender who is 
    experienced in lending for vacant land. Finding an option that is most suitable 
    for their situation will be important.
    `,
      },
      {
        title: `Additional Common Questions`,
        text: `<ol>
    <p>
    <li>Can you build on the land? If so, what are the restrictions? Are there any 
    easements, right-of-ways?</li>
    <li>Are there any minimum lot size requirements for building?</li>
    <li>Is there potential for contaminated soil or past industrial use?</li>
    <li>Is there any Environmental Protection that may be associated with water 
    sources on the property like rivers and flood plains?</li>
    <li>How much work needs to be done on the property before it's ready for 
    development/use. Will trees have to be cleared?</li>
    <li>Does the land have year-round access? What is the proximity to the 
    highway, services and school? What services are nearby?</li>
    <li>How long has the land been on the market? This can be telling as it may indicate 
    that others have done their homework and discovered issues. This can also be an 
    indication of how hard it will be for your client to sell the land down the road.</li>
    <li>Does the property face east, west, north or south? This may seem redundant, 
    but it's important to consider how the property and dream home will interact with 
    the sunrise and sunset.</li>
    <li>How far North is it located? If you're coming from the South, you're likely 
    acclimated to more mild winters. The further North you go, the longer the winter 
    season lasts.</li>
    <li>Soil type - Different types of soil in Ontario can have a huge impact on the 
    usability of land. You'll want to find out if there are any drainage issues or 
    other concerns that may affect your ability to use and develop the property.</li>
    <li>Are there plans for future development in the area which may affect the use & 
    enjoyment of the property? (contact local municipality)</li>
    <li>Are there any Species at Risk or natural heritage features present?</li>
    </ol>
    </p>`,
      },
      {
        title: `Typical Conditions in an Offer`,
        text: `
    <p>No two properties are alike which means that each purchase will be 
    structured differently depending on the situation. If your client wants to "buy 
    now and figure it out later", ensure you complete Form 127. Thoroughly educate 
    your client on the risks of not including a due diligence clause. It will be 
    extremely important for your client to have a lawyer that is experienced in 
    this type of transaction.
    <br/><br/>
    As these transactions can involve multiple conditions and extensive due 
    diligence, consider incorporating a general due diligence clause in your offer. 
    This provides the ability to conduct thorough evaluations and lets your client 
    choose whether to continue with the property purchase.<br/>
    Refer to the client's lawyer and the 
    <a
      href="https://www.orea.com/standard-forms-clauses"
      target="_blank"
      rel="noopener noreferrer"
    >
      OREA Clause Booklet</a> for any additional clauses that may be required.
    <br/><br/>

    <strong>Always Include a Lawyer Review Condition</strong> plus the due
    diligence clause below.<br/><br/>

    <strong>Due Diligence Clause:</strong>
    <br/>
    This Offer is conditional upon the Buyer being able to conduct due diligence for 
    a period of _________ days from the date of acceptance of the Agreement of 
    Purchase and Sale. During this period, the Buyer shall have access to the property 
    for inspections, assessments, and investigations deemed necessary. Unless the 
    Buyer gives notice in writing delivered to the Seller personally or in accordance 
    with any other provisions for the delivery of notice in this Agreement of Purchase 
    and Sale or any Schedule, that this condition is fulfilled, this Offer shall be 
    null and void and the deposit shall be returned to the Buyer in full without 
    deduction. The Seller agrees to co-operate in providing access to the property 
    for the purpose of these investigations. This condition is included for the 
    benefit of the Buyer and may be waived at the Buyer's sole option by notice 
    in writing to the Seller as aforesaid within the time period stated herein.
    <br/>

    <br/>If your client/lawyer wishes to go with individual conditions, consider 
    including the following conditions in the offer. Depending on the  situation, 
    some of these conditions may not be applicable. You may require additional 
    conditions that aren't listed here. </p>
    <br/>
    Conditional Upon:
    <ol>
    <p>
    <li>Lawyer's Review (highly recommended)</li>
    <li>Financing</li>
    <li>Finding out availability of connecting to hydro, water, septic/sewer, 
    internet, etc.</li>
    <li>Obtaining a Building Permit</li>
    <li>Buyer obtaining / Seller providing a Survey</li>
    <li>Verifying Zoning</li>
    <li>Testing well water and Septic systems</li>
    <li>Conducting Environmental Tests</li>
    <li>Performing a Soil Test/Septic Suitability Test</li>
    <li>Satisfactory site assessment/evaluation</li>
    <li>Verifying environmental status with Conservation Authority</li>
    <li>Verifying Legal Road Access</li>
    <li>Completion of Severance</li>
    </ol>
    </p>`,
      },
    ],
  },

  {
    type: "transaction topic",
    id: "singleFamily",
    title: "Single Family Residential (Resale)",
    description: `<p>
    This is typically the most common type of  real estate transaction in most 
    communities. The property may be a single family home, duplex, triplex, 
    or fourplex.
    <br/><br/>
    Evaluating the property requires attention to a wide range of factors, 
    all of which can differ depending on each client's individual goals and priorities. 
    Because your client's priorities may change as they tour properties, having a 
    clear understanding of their initial goals is vital to guiding them effectively 
    through the home-buying process. 
    <br/><br/>
    Every transaction/property is unique, and the guidance provided may not address all 
    situations. REALTORS® are expected to perform proper due diligence and advocate  
    for their clients, in line with professional standards. If it's your first time 
    handling this type of deal, working with a more experienced REALTOR® is strongly 
    recommended—not only to protect your client's best interests and ensure 
    competent service, but also to benefit from the opportunity to learn from their 
    experience.
  </p>`,
    text: [
      {
        title: "Common Due Diligences",
        text: `
      
      <strong>Size, Layout, and Features</strong><br/>
      Ensure the home meets your client's needs in terms of size, layout, and 
      features. Consider layout, number of bedrooms, bathrooms, and any other features 
      that are important to them. If future growth is a consideration, keep that 
      in mind as well when evaluating the property.
      <br/><strong class="bold">Action:</strong> Work with your client to identify 
      and prioritize the features that are must-haves versus nice-to-haves.
      <br/><br/>

      <strong>Location: Neighbourhood and Amenities</strong><br/>
      Consider proximity to schools, transit, hospitals, parks, and commercial areas.
      <br/><strong class="bold">Action:</strong> Discuss with your client their 
      priorities regarding proximity to work, schools, public transit, shopping, 
      and healthcare. Research neighbourhood safety, future development plans, and 
      recent sales to assess resale value potential.
      <br/><br/>

      <strong>Property Condition</strong><br/>
      Understand the current condition of the home, including structural integrity, 
      roofing, plumbing, HVAC systems, foundation, and electrical systems. Items 
      like flooring & paint are relatively inexpensive updates.
      <br/><strong class="bold">Action:</strong> Ask the listing agent any questions 
      that come up to reconfirm discoveries during the viewing/inspection. Be sure to 
      arrange for a qualified home inspector, assuming a home inspection condition 
      is included in the offer, at the appropriate stage of the process.
      <br/><br/>

      <strong>Age of Major Systems</strong><br/>
      Confirm age and service records for the roof, furnace, water heater, windows, 
      appliances, and any other major systems present in the home.
      <br/><strong class="bold">Action:</strong> Ask the Listing Agent/Seller for 
      utility costs, age, and service records. Include this assessment in your offer 
      strategy.
      <br/><br/>

      <strong>Zoning and Land Use</strong><br/>
      Ensure the property's current and intended use complies with municipal zoning 
      by-laws. If the property has multiple units, ensure they are legal and the 
      zoning allows their use & existence.
      <br/><strong class="bold">Action:</strong> Check municipal zoning maps or 
      consult the municipality's planning department to confirm legality of units
      and their use.
      <br/><br/>

      <strong>Improvements/Renovations</strong><br/>
      It's important to inquire about any improvements or renovations made to the 
      property. Knowing whether proper permits were obtained ensures that the work 
      was done legally and up to code, which can affect intended use, safety, 
      insurance, and future resale.
      <br/><strong class="bold">Action:</strong> Ask the Listing Agent/Seller for 
      details on any recent upgrades or renovations. Verify with them or the local 
      municipality whether the necessary permits were issued and approved for 
      those improvements.
      <br/><br/>

      <strong>Utilities and Services</strong><br/>
      Confirm access and condition of municipal water, sewer, hydro, gas, and 
      telecommunications.
      <br/><strong class="bold">Action:</strong> Confirm service providers and 
      inquire about any past issues with connectivity or service interruptions.
      <br/><br/>

      <strong>Title and Ownership</strong><br/>
      Ensure the title is free and clear of any liens, easements, restrictive 
      covenants, or encumbrances.
      <br/><strong class="bold">Action:</strong> Request a title report from 
      GeoWarehouse and have the client's lawyer review for any legal complications 
      or shared access issues.
      <br/><br/>

      <strong>Environmental Concerns</strong><br/>
      Investigate potential contamination (e.g., oil tanks, radon, mold) or water 
      drainage issues.
      <br/><strong class="bold">Action:</strong> Ask the Listing Agent/Seller for 
      any information that may be relevant to the property. Consider additional 
      inspections if needed.
      <br/><br/>

      <strong>Insurance and Risk Factors</strong><br/>
      Consider proximity to floodplains and the age/type of wiring or plumbing.
      <br/><strong class="bold">Action:</strong> Encourage clients to obtain an 
      insurance quote early to ensure affordability and coverage. If items like 
      wiring or plumbing are old, consider additional inspections.
      `,
      },
      {
        title: "Financing & Appraisal",
        text: `
      <strong>Mortgage Pre-Approval</strong><br/>
      A pre-approval helps strengthen your client's offer and identifies a clear 
      budget.
      <br/><strong class="bold">Action:</strong> Connect your client with a trusted 
      mortgage broker or lender before house hunting. Offer them a minimum 
        of three lender referrals and encourage open conversations with each, 
        allowing them to make the most informed choice based on their needs.
      <br/><br/>

      <strong>Appraisal Requirements</strong><br/>
      Lenders typically require an appraisal to confirm property value aligns with loan amount.
      <br/><strong class="bold">Action:</strong> Work with the lender to schedule a 
      timely appraisal post-conditional acceptance.
      <br/><br/>

      <strong>Deposit Amount</strong><br/>
      Deposits for resale homes typically range from 5-10% of the purchase price.
      <br/><strong class="bold">Action:</strong> Discuss a deposit strategy with your 
      client, factoring in local market competitiveness.
      `,
      },
      {
        title: "Additional Common Questions",
        text: `
      <ol>
      <li>What is the home's history of ownership and maintenance?</li>
      <li>Has the home been recently renovated? Were permits obtained?</li>
      <li>Are there any upcoming assessments, levies, or zoning changes?</li>
      <li>Are property taxes up to date?</li>
      <li>How long has the home been on the market and why?</li>
      <li>Is there any history of flooding or foundation issues?</li>
      <li>What schools and amenities are in the area?</li>
      <li>Are there restrictive covenants or easements on the property?</li>
      <li>What are the average monthly costs for utilities and maintenance?</li>
      <li>Is the home still covered under the Tarion Warranty?</li>
      </ol>
      `,
      },
      {
        title: "Offer Practices & Conditions/Clauses",
        text: `
      <strong>Offer Best Practices</strong><br/>
      <ol>
      <li>"Time is of the essence" when it comes to agreements. Make sure that 
      agreements and related deal documents are signed within their designated 
      time frames.</li>
      <li>Confirm that all OREA forms and clauses used are both current and 
      appropriate for the specific deal.</li>
      <li>Check the MLS Listing for any supplemental documents to be included with 
      the offer.</li>
      <li>Deposit delivery must occur within the specified time frame on the agreement. 
      If the deposit isn't delivered, the client is in breach and may face legal 
      action. </li>
      <li>Always assign a firm date to conditions and clauses. Phrases like "5 
      business days" can cause confusion and conflict. A set deadline makes 
      expectations clear for everyone involved.</li>
      </ol>

      <br/>
      <strong>Conditions & Clauses</strong><br/>
      If a client chooses to not include a condition in their offer, it is important 
      to ensure they understand the risks and are comfortable with the potential 
      consequences. Furthermore, ensure you complete FORM 127 for situations where 
      your clients choose to not include a recommended condition in the offer.
      <br/><br/>
      It is always best practice to include a Buyer's Lawyer Review condition in 
      the offer, especially if the property has unique characteristics that 
      require further investigation.
      <br/><br/>
      Review the <a
      href="/SK/transaction-checklists"
      rel="noopener noreferrer"
    >
      Transaction Checklists</a> section to view & better understand common 
      conditions and how they may apply to your client's specific needs for this 
      type of transaction.<br/><br/>

      
      `,
      },
    ],
  },
  {
    type: "transaction topic",
    id: "condo",
    title: "Residential Condo (Resale)",
    description: `<p>
    Purchasing a condominium involves acquiring a unit in a shared 
    residential development, where individual ownership typically includes the 
    interior unit space while shared ownership exists for common elements such as 
    lobbies, hallways, gyms, and outdoor spaces. This form of ownership is 
    governed by the <em>Condominium Act, 1998</em>.
    <br/><br/>
       Evaluating the property requires attention to a wide range of factors,
   all of which can differ depending on each client's individual goals and priorities.
   Because your client's priorities may change as they tour properties, having a
   clear understanding of their initial goals is vital to guiding them effectively
   through the home-buying process.
   <br/><br/>
   Every transaction/property is unique, and the guidance provided may not address all
   situations. REALTORS® are expected to perform proper due diligence and advocate for
   their clients, in line with professional standards. If it's your first time
   handling this type of deal, working with a more experienced REALTOR® is strongly
   recommended—not only to protect your client's best interests and ensure
   competent service, but also to benefit from the opportunity to learn from their
   experience.

    </p>`,
    text: [
      {
        title: "Common Due Diligences",
        text: `
        
        Review the Single Family Residential (Resale) section, as many of those 
        considerations will apply to condos as well. For condos specifically, here 
        are some additional items to consider.
        <br/><br/>
         The <a href="https://www.condoauthorityontario.ca/" rel="noopener noreferrer" 
        target="_blank">Condo Authority of Ontario</a> is a valuable resource for 
        learning about condo ownership and living. Encourage your client to 
        review it before purchasing a condo.
        <br/><br/>

        <strong>Status Certificate Review</strong><br/>
        A status certificate outlines the financial and legal standing of the condo 
        corporation, including budgets, reserve fund balance, ongoing litigation, and 
        special assessments. Additionally, it outlines any condo rules, bylaws, and 
        restrictions.
        <br/><strong class="bold">Action:</strong> Request a status certificate 
        and have it reviewed by your client's lawyer before fulfilling conditions. 
        This will require the status certificate condition in the offer.
        Always use a recent status certificate, as details can change. Don't rely 
        on one from the Listing Agent or Seller, especially if it's outdated.
        <br/><br/>
  
        <strong>Condo Rules, Bylaws & Restrictions</strong><br/>
        Understand pet policies, renovation limits, short-term rental restrictions, 
        and noise or usage rules.
        <br/><strong class="bold">Action:</strong> Review condominium bylaws and 
        declaration with the Buyer to align with their lifestyle expectations.
        <br/><br/>
  
        <strong>Monthly Maintenance Fees</strong><br/>
        These fees cover building operations and reserve fund contributions. Fees vary 
        depending on amenities and property age.
        <br/><strong class="bold">Action:</strong> Obtain the most recent budget and 
        maintenance breakdown from the status certificate to assess fees and 
        what is included in the fees.
        <br/><br/>
  
        <strong>Improvements/Renovations</strong><br/>
        It's important to inquire about any improvements or renovations made to the 
        unit. Knowing whether proper permits and condo corporation approvals were 
        obtained helps to ensure that the work was done legally and up to code, which 
        can affect intended use, safety, insurance, and future resale.
        <br/><strong class="bold">Action:</strong> Ask the Listing Agent/Seller for 
        details on any recent upgrades or renovations. Verify with them or the condo 
        corporation whether the necessary permits/approvals were obtained and 
        approved for those improvements.
        <br/><br/>
  
        <strong>Common Element Inclusions</strong><br/>
        Clarify what the maintenance fees cover (utilities, parking, locker, 
        concierge, amenity access, etc.).
        <br/><strong class="bold">Action:</strong> Review the listing and confirm 
        in the status certificate, which outlines inclusions and exclusions. Contact 
        the property management company to confirm the details.
        <br/><br/>
  
        <strong>Insurance Responsibilities</strong><br/>
        Owners must usually obtain interior and liability insurance independently, as 
        the condo corporation's policy usually only applies to the building envelope 
        and common property areas.
        <br/><strong class="bold">Action:</strong> Educate clients on what their 
        personal policy must cover. Generally this involves liability and interior 
        coverage. Requirements are typically outlined in the condo bylaws.
        <br/><br/>
  
        <strong>Building Reputation & Management</strong><br/>
        Management quality impacts maintenance, responsiveness, and resale value.
        <br/><strong class="bold">Action:</strong> Search reviews, ask existing 
        owners, and assess building upkeep during the showing.
        <br/><br/>

        <strong>Accessibility</strong><br/>
        If your client requires accessibility features, ensure the building suits 
        their needs. Such examples are zero-step entry, wide hallways, ramps, and 
        accessible parking.
        <br/><strong class="bold">Action:</strong> Confirm with your clients that 
        the building is accessible and meets their needs. If it is not, inquire with 
        the condo corporation about the potential solutions and approval processes.
        <br/><br/>

        <strong>Parking & Lockers</strong><br/>
        Parking and storage lockers are important assets that can significantly 
        affect your client's convenience, security, resale value, and legal rights. 
        With parking, the spots may be separately titled, exclusive use or assigned.
        Separately titled spots will have a separate PIN/legal description to be 
        included in the offer. Exclusive spots are owned by the condo corporation 
        with the exclusive use tied to the unit. 
        <br/><strong class="bold">Action:</strong> Confirm the type of parking that 
        is available and whether it is included in the purchase price. Additionally, 
        confirm how it is structured so the offer can be properly drafted. 
        <br/><br/>
        `,
      },
      {
        title: "Financing & Appraisal",
        text: `
        <strong>Mortgage Pre-Approval</strong><br/>
        Lenders may assess not only the Buyer but also the building's financial 
        health.
        <br/><strong class="bold">Action:</strong> Connect your client with a 
        trusted mortgage broker or lender before house hunting. Offer them a minimum 
        of three lender referrals and encourage open conversations with each, 
        allowing them to make the most informed choice based on their needs.
        <br/><br/>
  
        <strong>Appraisal Process</strong><br/>
        Lenders typically require an appraisal to confirm property value 
        aligns with loan amount.
        <br/><strong class="bold">Action:</strong> Work with the lender to schedule 
        a timely appraisal post-conditional acceptance.
        <br/><br/>
  
        <strong>Deposit Considerations</strong><br/>
        Deposits typically range between 5-10% of the purchase price.
        <br/><strong class="bold">Action:</strong> Strategize with your client on 
        deposit size based on competition and financing strength.
        `,
      },
      {
        title: "Additional Common Questions",
        text: `
        <ol>
        <li>What does the maintenance fee cover and how often is it adjusted?</li>
        <li>Are there any upcoming special assessments or capital projects planned?</li>
        <li>What amenities are included and are they in good condition?</li>
        <li>Is the parking and locker included in the purchase price and on title?</li>
        <li>How strong is the reserve fund and when was the last study completed?</li>
        <li>Are there restrictions on pets, rentals, or renovations?</li>
        <li>How responsive and reputable is the property management company?</li>
        <li>What is the building's insurance policy coverage and deductible structure?</li>
        <li>Have there been recent lawsuits or litigation involving the condo corporation?</li>
       <li>Is the home still protected by the Tarion New Home Warranty?</li>
        </ol>
        `,
      },
      {
        title: "Offer Practices & Conditions/Clauses",
        text: `
         <strong>Offer Best Practices</strong><br/>
      <ol>
      <li>"Time is of the essence" when it comes to agreements. Make sure that 
      agreements and related deal documents are signed within their designated 
      time frames.</li>
      <li>Confirm that all OREA forms and clauses used are both current and 
      appropriate for the specific deal.</li>
      <li>Check the MLS Listing for any supplemental documents to be included with 
      the offer.</li>
      <li>Deposit delivery must occur within the specified time frame on the agreement. 
      If the deposit isn't delivered, the client is in breach and may face legal 
      action. </li>
      <li>Always assign a firm date to conditions and clauses. Phrases like "5 
      business days" can cause confusion and conflict. A set deadline makes 
      expectations clear for everyone involved.</li>
      </ol>

      <br/>
      <strong>Conditions & Clauses</strong><br/>
        If a client chooses to not include a condition in their offer, it is important 
      to ensure they understand the risks and are comfortable with the potential 
      consequences. Furthermore, ensure you complete FORM 127 for situations where 
      your clients choose to not include a recommended condition in the offer.
      <br/><br/>
      It is always best practice to include a Buyer's Lawyer Review condition in 
      the offer, especially if the property has unique characteristics that 
      require further investigation.
      <br/><br/>
      Review the <a
      href="/SK/transaction-checklists"
      rel="noopener noreferrer"
    >
      Transaction Checklists</a> section to view & better understand common 
      conditions and how they may apply to your client's specific needs for this 
      type of transaction.<br/><br/>
        `,
      },
    ],
  },
  {
    type: "transaction topic",
    id: "preconcondo",
    title: "Pre-Construction Condo",
    description: `<p>
    Purchasing a pre-construction condo involves buying a unit that 
    has not yet been built or is under construction, typically directly from the 
    developer or working with the agent representing them. These transactions differ 
    significantly from resale purchases, involving extended timelines, more complex 
    contracts, and unique rights under the <em>Condominium Act, 1998</em>.
    <br/><br/>
    REALTORS® play a key role in guiding clients through the Agreement of Purchase and 
    Sale, understanding developer obligations, construction timelines, closing costs, 
    and the 10-day cooling-off period. Thorough review of documentation and 
    expectations is essential to protect the Buyer and ensure an informed experience.
    <br/><br/>
   Every transaction/property is unique, and the guidance provided may not address all
   situations. REALTORS® are expected to perform proper due diligence and advocate for
   their clients, in line with professional standards. If it's your first time
   handling this type of deal, working with a more experienced REALTOR® is strongly
   recommended—not only to protect your client's best interests and ensure
   competent service, but also to benefit from the opportunity to learn from their
   experience.
    </p>`,
    text: [
      {
        title: "Common Due Diligences",
        text: `
        The <a href="https://www.condoauthorityontario.ca/" rel="noopener noreferrer" 
        target="_blank">Condo Authority of Ontario</a> is a valuable resource for 
        learning about condo ownership and living. Encourage your client to 
        review it before purchasing a condo.
        <br/><br/>

        <strong>10-Day Cooling-Off Period</strong><br/>
        Ontario law allows Buyers 10 calendar days to rescind a pre-construction 
        condo purchase without penalty.
        <br/><strong class="bold">Action:</strong> Advise clients to consult a real 
        estate lawyer within this window to review the Builder's Agreement, 
        disclosure statement, and financial projections. Ensure you are familiar with 
        the processes and timelines for the cooling-off period, in case the client 
        wishes to exercise their right to rescind.
        <br/><br/>

        <strong>Builder Reputation</strong><br/>
        Before purchasing, it's essential to research the builder's history, 
        financial stability, and customer satisfaction. A reputable builder should 
        have a track record of delivering quality homes on time and as promised. 
        <br/><strong class="bold">Action:</strong> Research the Builder's reputation 
        through online reviews, news, and Tarion registration. Check for claims 
        history, visit past projects, and speak with previous Buyers and other agents 
        for firsthand insights. Ensure the Builder is registered with the Home 
        Construction Regulatory Authority (HCRA) and the property is enrolled in 
        Tarion.
        <br/><br/>

        <strong>Disclosure Statement</strong><br/>
        The disclosure statement includes key details about the future condo 
        corporation, such as proposed by-laws and rules, first-year budget, and any 
        agreements the Builder will enter before the condo is turned over 
        (e.g., management, repairs, landscaping).
        <br/><strong class="bold">Action:</strong> Ensure your client receives the 
        disclosure statement and reviews it with a real estate lawyer. Note that 
        the 10-day cooling-off period starts once this document is delivered along 
        with the fully executed Builder's Agreement and the Condominium Guide.
        <br/><br/>

        <strong>Parking & Lockers</strong><br/>
        Parking and storage lockers are important assets that can significantly 
        affect your client's convenience, security, resale value, and legal rights. 
        With parking, the spots may be separately titled, exclusive use or assigned.
        <br/><strong class="bold">Action:</strong> Confirm the type of parking that 
        is available and whether it is included in the purchase price. Additionally, 
        confirm how it is structured. If these items come at an additional cost,  
        ensure your client understands the financial implications and is comfortable 
        with the additional cost.
        <br/><br/>

        <strong>Accessibility</strong><br/>
        If your client requires accessibility features, ensure the building suits their needs. Such examples are zero-step entry, wide hallways, ramps, and accessible parking.
        <br/><strong class="bold">Action:</strong> Confirm with your clients that the 
        building is accessible and meets their needs. If it is not, inquire with the 
        condo corporation about the potential solutions and approval processes.
        <br/><br/>
  
        <strong>Extended Timelines & Delays</strong><br/>
        Projects may be delayed due to construction, permit, or financing issues. 
        Occupancy may occur years after the purchase.
        <br/><strong class="bold">Action:</strong> Set expectations with clients about 
        tentative occupancy and final closing timelines as disclosed by the builder. 
        Reviewing the Builder's Agreement will outline the timelines and 
        responsibilities of the Builder and the Buyer.
        <br/><br/>

        <strong>Interim Occupancy vs Final Closing</strong><br/>
        Buyers often move in before they legally own the unit (interim occupancy) and 
        pay fees during this period.
        <br/><strong class="bold">Action:</strong> Explain the difference between 
        interim and final closing, and have a lawyer clarify financial obligations.
        <br/><br/>
  
        <strong>Closing Costs & Builder Fees</strong><br/>
        These can include development charges, levies, utility setup, Tarion enrolment, 
        and legal fees not typical in resale transactions.
        <br/><strong class="bold">Action:</strong> Educate your client on potential 
        builder-related closing costs early in the process. Coordinate with their 
        lawyer to review the Agreement of Purchase and Sale and Statement of 
        Adjustments, and attempt to negotiate caps on development charges and 
        builder fees where possible.
        <br/><br/>
  
        <strong>Tarion Warranty Program</strong><br/>
        New condos are covered under the Tarion New Home Warranty, which provides 
        protection against construction defects.
        <br/><strong class="bold">Action:</strong> Confirm the condo is enrolled in 
        the Tarion Program. Ensure your client is aware of what's covered and the 
        timelines for submitting claims. Direct them to the <a href="https://www.tarion.com/" rel="noopener noreferrer" 
        target="_blank">Tarion website</a> to learn more about the program and their 
        rights and obligations.
        <br/><br/>
  
        <strong>HST and Rebates</strong><br/>
        HST is included in most advertised prices but may be subject to eligibility 
        for the New Home Rebate.
        <br/><strong class="bold">Action:</strong> Confirm whether the price includes 
        HST and who is claiming the rebate (builder or Buyer).
        <br/><br/>
  
        <strong>Assignment Rights</strong><br/>
        Some agreements allow the Buyer to sell (assign) the unit before closing.
        <br/><strong class="bold">Action:</strong> Discuss with the developer and legal 
        counsel whether assignment is permitted and under what conditions/fees. Rights 
        and terms surrounding assignment of the unit are typically outlined in the 
        Builders Agreement.
        <br/><br/>

        
        `,
      },
      {
        title: "Financing & Deposits",
        text: `
        <strong>Deposit Structure</strong><br/>
        Deposits are typically paid in stages (e.g., 5% at signing, 5% in 90 days, 
        etc.).
        <br/><strong class="bold">Action:</strong> Review the deposit schedule in the 
        builder agreement and confirm funds availability with the Buyer.
        <br/><br/>
  
        <strong>Mortgage Pre-Approval Limitations</strong><br/>
        Since final closing may be years away, most lenders won't lock in rates far 
        in advance.
        <br/><strong class="bold">Action:</strong> Have the client speak to a mortgage 
        professional about pre-qualification and potential changes in borrowing power.
        <br/><br/>
  
        `,
      },
      {
        title: "Additional Common Questions",
        text: `
        <ol>
        <li>What is the builder's reputation and project history?</li>
        <li>Are assignment rights included, and what are the associated fees?</li>
        <li>What is the anticipated occupancy and final closing date?</li>
        <li>Are development charges and levies capped?</li>
        <li>What are the estimated monthly maintenance fees?</li>
        <li>Is parking and locker included in the price or sold separately?</li>
        <li>Is the HST included in the purchase price and who claims the rebate?</li>
        <li>How long is the interim occupancy period expected to last?</li>
        <li>What warranties are provided by Tarion and the builder?</li>
        </ol>
        `,
      },
      {
        title: "Offer Practices & Conditions/Clauses",
        text: `
        <strong>Offer Best Practices</strong><br/>
      <ol>
      <li>"Time is of the essence" when it comes to agreements. Make sure that 
      agreements and related deal documents are signed within their designated 
      time frames.</li>
      <li>Fully review the Builder's Agreement to understand and educate the client
      on what their rights and obligations are.</li>
      <li>If listed, check the MLS Listing for any supplemental documents to be 
      included with the offer.</li>
      <li>Deposit delivery must occur within the specified time frame on the agreement. 
      If the deposit isn't delivered, the client is in breach and may face legal 
      action. </li>
      </ol>

      <br/>
      <strong>Conditions & Clauses</strong><br/>
        If a client chooses to not include a condition in their offer, it is important 
      to ensure they understand the risks and are comfortable with the potential 
      consequences. Furthermore, ensure you complete FORM 127 for situations where 
      your clients choose to not include a recommended condition in the offer.
      <br/><br/>
      It is always best practice to include a Buyer's Lawyer Review condition in 
      the offer. Builder's Agreements can be very complex and it is important to 
      ensure your client understands the terms and conditions of the agreement.
      <br/><br/>
      Review the <a
      href="/SK/transaction-checklists"
      rel="noopener noreferrer"
    >
      Transaction Checklists</a> section to view & better understand common 
      conditions and how they may apply to your client's specific needs for this 
      type of transaction.<br/><br/>

        
        `,
      },
    ],
  },
  {
    type: "transaction topic",
    id: "assignment",
    title: "Assignments (Pre-Construction)",
    description: `<p>
    An Assignment involves a Seller (Assignor) transferring their 
    rights and obligations under an Agreement of Purchase and Sale to another Buyer 
    (Assignee) before the original transaction is completed. This is most common in 
    pre-construction condo transactions but can also apply to freehold properties if 
    permitted. Essentially, the Buyer is buying the Seller's contract and assuming 
    it from when the assignment is finalized. Typically the completion of the 
    assignment occurs once the Builder has given consent for the assignment.
    <br/><br/>
    REALTORS® must ensure that both parties understand the legal and financial 
    implications of assignments, which often include builder/developer consent, 
    additional fees, and unique closing considerations. Legal review and proper 
    disclosures are essential to protect all parties.
    <br/><br/>
    Every transaction/property is unique, and the guidance provided may not address 
    all situations. REALTORS® are expected to perform proper due diligence and 
    advocate for their clients, in line with professional standards. If it's your 
    first time handling this type of deal, working with a more experienced REALTOR® 
    is strongly recommended—not only to protect your client's best interests and 
    ensure competent service, but also to benefit from the opportunity to learn from 
    their experience.
    </p>
    `,
    text: [
      {
        title: "Common Due Diligences",
        text: `
        Review the Single Family Residential (Resale) and Pre-Construction (Condos)
        section, as many of those considerations will apply to this scenario as well. 
        Here are some extra things to consider specifically when it comes to 
        assignments.
        <br/><br/>

       <strong>Original Purchase Agreement</strong><br/>
        Reviewing the original purchase agreement is a key step, as it forms the 
        foundation of the assignment agreement. It offers clear insight into the terms 
        and conditions, including the rights and responsibilities of all parties, 
        assignment provisions, timelines, deposits, and buyer obligations.
        <br/><strong class="bold">Action:</strong> Obtain and review the Original 
        Purchase Agreement to confirm the details of what is being assigned. Most of 
        the due diligences listed below will apply to the original purchase agreement.
        <br/><br/>

        <strong>Builder Consent</strong><br/>
        Most pre-construction assignments require written consent from the Builder, 
        often subject to a fee and legal review.
        <br/><strong class="bold">Action:</strong> Confirm whether the original 
        Builders Agreement permits assignments and under what conditions.
        <br/><br/>
  
        <strong>Assignment Fees and Conditions</strong><br/>
        Builders typically charge administrative, legal, and consent fees. Some limit 
        when the assignment can occur (e.g., only after 80% of units are sold).
        <br/><strong class="bold">Action:</strong> Review the Builders Agreement and 
        disclosure statement for all fees, restrictions, and timing windows. 
        <br/><br/>
  
        <strong>Profit & Tax Implications</strong><br/>
        Assignors (Seller) may sell the contract at a profit, but are typically 
        subject to HST and capital gains or business income tax. Buyers who intend 
        to rent the property are generally ineligible for the HST rebate on closing 
        and must  pay it out of pocket.
        <br/><strong class="bold">Action:</strong> Advise clients to speak to an 
        accountant about potential tax liabilities and ensure CRA compliance.
        <br/><br/>

        <strong>Profit Payment Timing</strong><br/>
        Assignors often seek profit upfront, but this poses significant risks if the 
        project fails to close or is canceled by the builder.
        <br/><strong class="bold">Action:</strong> Structure the assignment agreement 
        so that any profit is paid on final closing, not at the time of assignment.
        <br/><br/>

        <strong>Buying/Selling at a Loss</strong><br/>
        While uncommon, some Builders restrict assignments that involve a sale below 
        the original purchase price, as this can negatively impact future property 
        valuations. When an assignment is sold at a loss, it's crucial to ensure 
        the financial shortfall is properly addressed within the agreement.
        <br/><strong class="bold">Action:</strong> If the assignment is being sold 
        at a loss, confirm that sufficient funds are available—often covered by 
        the forfeiture of the Assignor's deposits—and clearly outline this within 
        the Assignment Agreement.
        <br/><br/>
  
        <strong>Transparency & Disclosure</strong><br/>
        Assignees must be fully informed about the original agreement's terms and any 
        changes made prior to assignment.
        <br/><strong class="bold">Action:</strong>  
        Ask the Listing Agent/Seller for the existence of any amendments or changes 
        to the agreement. Include all supporting documents in the Assignment Agreement 
        and ensure the Assignee (Buyer) acknowledges existing obligations.
        <br/><br/>
  
        <strong>Legal Review of All Agreements</strong><br/>
        Assignment transactions involve multiple layers of legal review: the Original 
        APS, the Builder's consent, and the new Assignment Agreement.
        <br/><strong class="bold">Action:</strong> Ensure your clients retain a 
        lawyer early in the process and coordinate timelines for reviews and approvals. 
        It is important to ensure the lawyer is experienced in this type of transaction.
        <br/><br/>

        <strong>Closing Cost Surprises</strong><br/>
        Uncapped adjustments—such as development levies or meter installations—can 
        amount to tens of thousands of dollars, often catching Buyers by surprise.
        <br/><strong class="bold">Action:</strong> Check the original Builders 
        Agreement to see if caps were negotiated on closing adjustments or ensure 
        Assignors assume excess costs beyond a set threshold.
        <br/><br/>

        <strong>Rebate and Document Transfer</strong><br/>
        Assignors may receive builder rebates, warranties, and deficiency lists 
        which Assignees (Buyer) must access for full entitlement.
        <br/><strong class="bold">Action:</strong> Include clauses in the agreement 
        obligating Assignors to transfer all relevant Builder documents and 
        benefits to the Assignee.
        <br/><br/>
        
        `,
      },
      {
        title: "Financing & Payment Structure",
        text: `
        <strong>Deposit Transfers</strong><br/>
        The Assignee (Buyer) typically reimburses the Assignor (Seller) for the 
        deposits paid to date, and may also pay an additional assignment premium.
        <br/><strong class="bold">Action:</strong> Clarify the deposit amounts, 
        payment schedule, and any amounts still owing to the Builder. This will 
        potentially vary depending on when the assignment is being finalized.
        <br/><br/>
  
        <strong>Financing for Assignment Purchases</strong><br/>
        Some lenders are hesitant to finance assignment transactions due to timing, 
        legal complexity, or valuation risks.
        <br/><strong class="bold">Action:</strong> Refer the Assignee to mortgage 
        professionals with experience in Assignment financing.
        <br/><br/>
  
        <strong>Final Closing Obligations</strong><br/>
        The Assignee assumes all closing costs, levies, and obligations from the 
        original agreement at final closing.
        <br/><strong class="bold">Action:</strong> Ensure Assignees understand all 
        projected closing costs, including capped or uncapped development charges.
        `,
      },
      {
        title: "Additional Common Questions",
        text: `
        <ol>
        <li>Is the original APS assignable, and has the Builder approved it?</li>
        <li>What is the total profit or premium being paid to the Assignor?</li>
        <li>Is the assignment being sold at a loss? Who is responsible for the loss?</li>
        <li>Are there any Assignment fees, restrictions, or blackout periods?</li>
        <li>How will deposits be transferred or reimbursed?</li>
        <li>What are the HST implications for the Assignment profit?</li>
        <li>Are there any changes to the unit or closing terms?</li>
        <li>Has the Assignee secured financing?</li>
        <li>What documents must be provided to the Builder and the lawyer?</li>
        <li>Does the Assignee understand all builder closing adjustments and levies?</li>
        </ol>
        `,
      },
      {
        title: "Offer Best Practices & Conditions/Clauses",
        text: `

         <strong>Offer Best Practices</strong><br/>
      <ol>
      <li>"Time is of the essence" when it comes to agreements. Make sure that 
      agreements and related deal documents are signed within their designated 
      time frames.</li>
      <li>Confirm that all OREA forms and clauses used are both current and 
      appropriate for the specific deal.</li>
      <li>Check the MLS Listing for any supplemental documents to be included with 
      the offer.</li>
      <li>Deposit delivery must occur within the specified time frame on the agreement. 
      If the deposit isn't delivered, the client is in breach and may face legal 
      action. </li>
      <li>Always assign a firm date to conditions and clauses. Phrases like "5 
      business days" can cause confusion and conflict. A set deadline makes 
      expectations clear for everyone involved.</li>
      </ol>

      <br/>
      <strong>Conditions & Clauses</strong><br/>
        If a client chooses to not include a condition in their offer, it is important 
      to ensure they understand the risks and are comfortable with the potential 
      consequences. Furthermore, ensure you complete FORM 127 for situations where 
      your clients choose to not include a recommended condition in the offer.
      <br/><br/>
      It is always best practice to include a Buyer's Lawyer Review condition in 
      the offer, especially if the property has unique characteristics that 
      require further investigation.
      <br/><br/>
      Review the <a
      href="/SK/transaction-checklists"
      rel="noopener noreferrer"
    >
      Transaction Checklists</a> section to view & better understand common 
      conditions and how they may apply to your client's specific needs for this 
      type of transaction.<br/><br/>

      Typically all pre-construction assignments should have the following at minimum:
        <br/><br/><strong>Builder Consent Condition</strong><br/>
        This condition ensures the developer/builder formally approves the assignment 
        before it becomes binding.
        <br/><br/>
  
        <strong>Assignor & Assignee Lawyer Review Condition</strong><br/>
        Both parties should have the right to legal review of the assignment agreement 
        and original APS.
        <br/><br/>
  
        <strong>Other Key Clauses</strong>
        <ol>
          <li>Financing Condition</li>
          <li>Deposit Verification Clause (Confirms the Assignor has paid all 
          deposits to date)</li>
          <li>Tax allocation (e.g., HST applicable on profit)</li>
          <li>Inclusion of all builder amendments or upgrades</li>
          <li>Representation and warranties that the unit is unencumbered</li>
          <li>Provision of updated Statement of Adjustments</li>
        </ol>
        `,
      },
    ],
  },
  {
    type: "transaction topic",
    id: "FSBO",
    title: "For Sale by Owner (Residential Resale)",
    description: `<p>
    Purchasing a property directly from a private Seller — also known as a For Sale By 
    Owner (FSBO) transaction — involves buying without the Seller being represented by 
    a REALTOR®. While FSBO sales may appear simpler or more 
    cost-effective, they can present added risks, legal gaps, and communication 
    challenges for the Buyer and their REALTOR®.
    <br/><br/>
    REALTORS® working with Buyers must ensure rigorous due diligence, 
    careful negotiation, and clear communication. It's crucial to protect the Buyer's 
    interests through thorough documentation & lawyer involvement.
    <br/><br/>
    Every transaction/property is unique, and the guidance provided may not address 
    all situations. REALTORS® are expected to perform proper due diligence and 
    advocate for their clients, in line with professional standards. If it's your 
    first time handling this type of deal, working with a more experienced REALTOR® 
    is strongly recommended—not only to protect your client's best interests and 
    ensure competent service, but also to benefit from the opportunity to learn from 
    their experience.
    </p>
    `,
    text: [
      {
        title: "Common Due Diligences",
        text: `
        Review the Single Family Residential (Resale) or Residential Condo (Resale) 
        section, as many of those considerations will apply to this scenario as well. 
        For For Sale By Owner (FSBO) properties, here are some additional items to 
        consider.
        
        <br/><br/>
        <strong>Unrepresented Seller Risk</strong><br/>
        FSBO Sellers may be unfamiliar with standard real estate processes, 
        documentation, or disclosure obligations.
        <br/><strong class="bold">Action:</strong> Clearly explain the REALTOR®'s role 
        to both Buyer and Seller. Providing the RECO Guide early in the process is 
        not only required by the legislation but also important to ensure the Seller 
        understands their rights and obligations.
        <br/><br/>
  
        <strong>Seller Identification/Authority to Sell</strong><br/>
        FSBOs may not always have clear or verified authority to sell the property, 
        especially in cases involving estates, power of attorney, divorces, or shared  
        ownership.
        <br/><strong class="bold">Action:</strong> Request the Sellers identification 
        and compare against GeoWarehouse to confirm proof of ownership and legal 
        authority to sell. If it is a power of attorney or estate situation, obtain 
        documents and have them approved by a lawyer. In an estate situation, many 
        FSBO Sellers are not aware of their need to complete Probate before a property 
        can close.
        <br/><br/>
  
        <strong>Property Disclosure and Inspection</strong><br/>
        FSBOs might not fully understand formal disclosure requirements or may leave 
        out known issues with the property.
        <br/><strong class="bold">Action:</strong> Encourage a comprehensive home  
        inspection and ask detailed questions about the property's history and condition.
        <br/><br/>
  
        <strong>Accurate Market Value & Negotiation</strong><br/>
        FSBOs may misprice their homes without comparable data. FSBO Sellers may be 
        emotionally invested in the property, leading to inflexible negotiation or 
        unrealistic expectations.
        <br/><strong class="bold">Action:</strong> Prepare a Comparative Market 
        Analysis (CMA) and use this to support your client's offer strategy. 
        Keep communications respectful and well-documented.
        <br/><br/>
  
        <strong>Clarity on Inclusions/Exclusions</strong><br/>
        Ambiguities often arise with chattels & fixtures.
        <br/><strong class="bold">Action:</strong> Confirm all inclusions/exclusions 
        in writing to avoid disputes. Complete your due diligence by ensuring you 
        have verified any rental equipment associated with the property.
        <br/><br/>

        <strong>Compliance with Zoning, Permits, and Renovations</strong><br/>
        FSBO Sellers might not disclose unpermitted renovations or zoning issues.
        <br/><strong class="bold">Action:</strong> Ask if any renovations were 
        done and if permits were obtained. Consult the Municipality for any concerns 
        regarding zoning as well as with the lawyer, if an offer is accepted.
        <br/><br/>
  
        <strong>Communication and Paperwork Challenges</strong><br/>
        Without a listing agent, logistics such as offer delivery, counteroffers, and 
        signatures require extra coordination.
        <br/><strong class="bold">Action:</strong> Clearly outline expectations and 
        timelines for the Seller and communicate often and in writing.
        <br/><br/>

        <strong>Title Review and Legal Support</strong><br/>
        Ensure title is clean and free of encumbrances, liens, or boundary issues.
        <br/><strong class="bold">Action:</strong> Involve a real estate lawyer early 
        and request a title search, especially if the Seller is unsure of legal 
        obligations. Additionally, purchase a Title Report from GeoWarehouse to 
        confirm the title is clean and free of encumbrances and/or liens.
        `,
      },
      {
        title: "Financing & Appraisal",
        text: `
        <strong>Financing Verification</strong><br/>
        FSBO Sellers may be unaware of conditional periods or lender needs.
        <br/><strong class="bold">Action:</strong> Explain conditional financing 
        clauses and timelines clearly to the Seller in writing.
        <br/><br/>
  
        <strong>Commission Agreements</strong><br/>
        Buyer agents should clarify their commission expectations with the Buyer and/or 
        the FSBO Seller.
        <br/><strong class="bold">Action:</strong> Negotiate the commission agreement 
        with the Seller before showing the property to the Buyer. If the Seller refuses 
        to include commission in the purchase price, talk to your Buyer about the 
        option of paying the commission out of pocket.
        <br/><br/>

        <strong>Mortgage Pre-Approval</strong><br/>
      A pre-approval helps strengthen your client's offer and identifies a clear 
      budget.
      <br/><strong class="bold">Action:</strong> Connect your client with a trusted 
      mortgage broker or lender before house hunting. Offer them a minimum 
        of three lender referrals and encourage open conversations with each, 
        allowing them to make the most informed choice based on their needs.
      <br/><br/>

      <strong>Appraisal Requirements</strong><br/>
      Lenders typically require an appraisal to confirm property value aligns with loan amount.
      <br/><strong class="bold">Action:</strong> Work with the lender to schedule a 
      timely appraisal post-conditional acceptance.
      <br/><br/>

      <strong>Deposit Amount</strong><br/>
      Deposits for resale homes typically range from 5-10% of the purchase price.
      <br/><strong class="bold">Action:</strong> Discuss a deposit strategy with your 
      client, factoring in local market competitiveness.
      <br/><br/>

      <strong>Deposit Handling</strong><br/>
      Due to the significant risks involved, deposits should not be held by FSBO 
      Sellers under any circumstances.
      <br/><strong class="bold">Action:</strong> Ensure the deposit is held by the 
      cooperating brokerage or buyer's lawyer, and outline this clearly in the 
      Agreement of Purchase and Sale.
      <br/><br/>

        `,
      },
      {
        title: "Additional Common Questions",
        text: `
        <ol>
        <li>Has the Seller done any renovations that require a permit?</li>
        <li>Are there any known defects, renovations, or unpermitted work?</li>
        <li>Is the Seller aware of their legal obligations?</li>
        <li>What is the Seller's expected closing date and reason for selling?</li>
        <li>Has the property been professionally appraised or assessed?</li>
        <li>What utilities, service providers, and warranties are in place?</li>
        <li>Is there a current survey or property boundary map available?</li>
        <li>Are there any easements, right-of-ways, or title issues?</li>
        <li>Will the Seller cooperate with requests for documents or inspections?</li>
        </ol>
        `,
      },
      {
        title: "Offer Best Practices & Conditions/Clauses",
        text: `
       <strong>Offer Best Practices</strong><br/>
      <ol>
      <li>"Time is of the essence" when it comes to agreements. Make sure that 
      agreements and related deal documents are signed within their designated 
      time frames.</li>
      <li>Confirm that all OREA forms and clauses used are both current and 
      appropriate for the specific deal.</li>
      <li>Deposit delivery must occur within the specified time frame on the agreement. 
      If the deposit isn't delivered, the client is in breach and may face legal 
      action. </li>
      <li>Always assign a firm date to conditions and clauses. Phrases like "5 
      business days" can cause confusion and conflict. A set deadline makes 
      expectations clear for everyone involved.</li>
      </ol>

      <br/>
      <strong>Conditions & Clauses</strong><br/>
      If a client chooses to not include a condition in their offer, it is important 
      to ensure they understand the risks and are comfortable with the potential 
      consequences. Furthermore, ensure you complete FORM 127 for situations where 
      your clients choose to not include a recommended condition in the offer.
      <br/><br/>
      It is always best practice to include a Buyer's Lawyer Review condition in 
      the offer, especially if the property has unique characteristics that 
      require further investigation.
      <br/><br/>
      Review the <a
      href="/SK/transaction-checklists"
      rel="noopener noreferrer"
    >
      Transaction Checklists</a> section to view & better understand common 
      conditions and how they may apply to your client's specific needs for this 
      type of transaction.<br/><br/>

        `,
      },
    ],
  },
  {
    type: "transaction topic",
    id: "tenantedProperty",
    title: "Residential (Tenant - Vacant Possession)",
    description: `<p>
    When purchasing a residential resale property that is currently 
    tenanted, Buyers seeking vacant possession must navigate both the terms of the 
    tenancy and the requirements under the <a
    href="https://www.ontario.ca/laws/statute/06r17"
    target="_blank"
    rel="noopener noreferrer"
    >Residential Tenancies Act (RTA)</a>. 
    Vacating tenants is not as simple as including a clause in the offer — legal 
    notice/agreements must be served/signed and specific criteria met. 
    Understanding the required processes and procedures of the <a
    href="https://tribunalsontario.ca/ltb/"
    target="_blank"
    rel="noopener noreferrer"
    > Landlord and Tenant Board (LTB)</a> is critical for serving your client's best 
    interests.
    <br/><br/>
    REALTORS® must advise Buyers on the lawful process to obtain vacant possession and 
    ensure the Seller can fulfill their obligations. Failure to handle tenant 
    termination correctly can delay closing or lead to litigation.
    <br/><br/>
    Every transaction/property is unique, and the guidance provided may not address all
    situations. REALTORS® are expected to perform proper due diligence and advocate for
    their clients, in line with professional standards. If it's your first time
    handling this type of deal, working with a more experienced REALTOR® is strongly
    recommended—not only to protect your client's best interests and ensure
    competent service, but also to benefit from the opportunity to learn from their
    experience.
    </p>
    `,
    text: [
      {
        title: "Common Due Diligences",
        text: `
        Review the Single Family Residential (Resale) or Residential Condo (Resale) 
        section, as many of those considerations will apply to this scenario as well. 
        For tenanted properties where vacant possession is needed, here are some 
        additional items to consider.
        <br/><br/>
        <strong>Tenant Rights Under the Law</strong><br/>
        Tenants have strong protections and cannot be forced to leave without lawful 
        notice and valid reason.
        <br/><strong class="bold">Action:</strong> Confirm with the 
        Listing Agent/Seller the status of the tenancy: lease term, rent amount, start 
        date, and any renewal terms. Inquire if the N11 - Agreement to End Tenancy 
        has already been signed and obtain a copy.
        <br/><br/>

        <strong>Assuming the Tenancy</strong><br/>
        If the Tenant is not cooperative, the Buyer may choose to assume the tenancy 
        and deal with the tenant directly in order to obtain vacant possession. This 
        scenario could lead to months before vacant possession is achieved. Once the 
        Buyer has closed and assumed the tenancy, the Seller is no longer responsible. 
        This is rarely an acceptable option to the Buyer, but it is an option.
        <br/><strong class="bold">Action:</strong> Discuss the risks of assuming the 
        tenancy with your client. If they choose to assume the tenancy, you should 
        recommend they engage a lawyer to review the lease and ensure they 
        are protected. Any damages to the property will be the responsibility of the 
        Buyer once the property is in their possession.
        <br/><br/>
  
        <strong>Buyer's Own Use Notice (Form N12)</strong><br/>
        To obtain vacant possession for Buyer's own use, the Seller must serve an N12 
        notice with at least 60 days' notice from the start of a rent period, plus 
        offer compensation or an alternative unit.
        <br/><strong class="bold">Action:</strong> Confirm that the Seller can 
        legally issue the N12 and that the closing date accommodates the required 
        notice period. Advise your client that vacant possession is not 
        guaranteed—tenants may refuse to leave, and Landlord and Tenant Board (LTB) 
        hearings can take months to resolve.
        <br/><br/>
  
        <strong>Use of N12 Must Be Genuine</strong><br/>
        Buyer must genuinely intend to move into the property or have a qualified 
        family member do so and reside there for at least one year.
        <br/><strong class="bold">Action:</strong> Make sure the Buyer understands the 
        legal declaration involved and risks of bad faith termination (including 
        tribunal fines).
        <br/><br/>

        <strong>Agreement to End Tenancy (Form N11)</strong><br/>
        An N11 is a mutual agreement between the landlord and tenant to end the 
        tenancy on a specific date. It is generally more reliable than serving an 
        N12, as it does better at avoiding potential disputes or delays through the 
        Landlord and Tenant Board (LTB).
        <br/><strong class="bold">Action:</strong> Where possible, negotiate an N11 
        signed by the tenant before firming up the deal. Confirm the agreed-upon 
        vacancy date and attach the signed form as part of the offer documentation.
        <br/><br/>
  
        <strong>Lease Type (Fixed-Term vs. Month-to-Month)</strong><br/>
        Fixed-term tenants cannot be evicted before the end of their term unless they 
        voluntarily agree (N11). Month-to-month tenants can be served with N12 if notice 
        conditions are met. However, even with proper notice, the tenant may still 
        choose not to vacate, potentially leading to a dispute and requiring a 
        hearing at the Landlord and Tenant Board (LTB) to enforce eviction.
        <br/><strong class="bold">Action:</strong> Confirm the Seller has met all 
        legal requirements for issuing the N12. Advise your client of the risks and 
        potential delays if the tenant contests the notice or refuses to leave. 
        Strongly recommend including a signed N11 condition in the offer, as it is 
        the most effective way to try and obtain vacant possession.
        <br/><br/>

        <strong>Future Rental Compliance</strong><br/>
        If the Buyer intends to rent out unit(s) in the future, it is essential 
        to confirm that the units are legally permitted for rental use.
        <br/><strong class="bold">Action:</strong> Verify zoning, licensing, and any 
        municipal regulations that apply to the property to ensure compliance. 
        Proceeding without confirming legality could result in fines, penalties, 
        restrictions on rental use, and litigation. It is critical that you conduct 
        proper due diligence to ensure the property can be used as intended. Strongly 
        recommend obtaining written confirmation of legal rental status before 
        finalizing the offer.
        `,
      },
      {
        title: "Financing & Appraisal",
        text: `
        <strong>Mortgage Pre-Approval</strong><br/>
        Lenders may assess not only the Buyer but also the building's financial 
        health.
        <br/><strong class="bold">Action:</strong> Connect your client with a 
        trusted mortgage broker or lender before house hunting. Offer them a minimum 
        of three lender referrals and encourage open conversations with each, 
        allowing them to make the most informed choice based on their needs.
        <br/><br/>
  
        <strong>Appraisal Process</strong><br/>
        Lenders typically require an appraisal to confirm property value 
        aligns with loan amount.
        <br/><strong class="bold">Action:</strong> Work with the lender to schedule 
        a timely appraisal post-conditional acceptance.
        <br/><br/>
  
        <strong>Deposit Considerations</strong><br/>
        Deposits typically range between 5-10% of the purchase price.
        <br/><strong class="bold">Action:</strong> Strategize with your client on 
        deposit size based on competition and financing strength.
        `,
      },
      {
        title: "Offer Strategy & Legal Support",
        text: `
       Engaging a lawyer early and having them review the offer is critical. 
       Include a lawyer review condition, as each situation can be unique and may 
       require a tailored approach. 
       <br/><br/>

        <strong>Condition for Vacant Possession</strong><br/>
        The offer should clearly state that vacant possession is required on closing 
        and contain condition(s) that are reasonable and achievable in the specific 
        circumstance.
        <br/><strong class="bold">Action:</strong> Recommend your clients  
        engage a lawyer to confirm notice timelines, lease implications, 
        and proper documentation. It is important to have a lawyer who is 
        experienced with this type of transaction.
        <br/><br/>
  
        <strong>Vacant Possession - Cash for Keys Option</strong><br/>
        This approach may be necessary if other methods to obtain vacant possession 
        are not viable. It involves negotiating a financial settlement with the 
        tenant in exchange for them agreeing to vacate the unit.
        <br/><strong class="bold">Action:</strong> Talk with your clients about 
        potentially offering to share the cost with the Seller if a cash-for-keys 
        arrangement is the only option. An N11 agreement must be signed to properly 
        document the tenant's consent to vacate. Legal guidance is strongly advised 
        to ensure compliance with all requirements. 
        <br/><br/>
        `,
      },
      {
        title: "Additional Common Questions",
        text: `
        <ol>
        <li>Is the tenancy fixed-term or month-to-month?</li>
        <li>Has an N11 been signed by the tenant? When is the agree-upon
        vacancy date?</li>
        <li>Is the tenant aware of the situation and cooperative?</li>
        <li>Is there enough time between firm deal and closing for the N12 period?</li>
        <li>Has a real estate lawyer reviewed the lease and notice?</li>
        <li>What happens if the tenant refuses to leave? Are there conditions in the 
        offer that address this?</li>
        <li>Are there any tribunal proceedings or complaints underway that may 
        prevent the sale from closing?</li>
        </ol>
        `,
      },
      {
        title: "Common Clauses and Conditions",
        text: `
        <strong>Offer Best Practices</strong><br/>
      <ol>
      <li>"Time is of the essence" when it comes to agreements. Make sure that 
      agreements and related deal documents are signed within their designated 
      time frames.</li>
      <li>Confirm that all OREA forms and clauses used are both current and 
      appropriate for the specific deal.</li>
      <li>Check the MLS Listing for any supplemental documents to be included with 
      the offer.</li>
      <li>Deposit delivery must occur within the specified time frame on the agreement. 
      If the deposit isn't delivered, the client is in breach and may face legal 
      action. </li>
      <li>Always assign a firm date to conditions and clauses. Phrases like "5 
      business days" can cause confusion and conflict. A set deadline makes 
      expectations clear for everyone involved.</li>
      </ol>

      <br/>
      <strong>Conditions & Clauses</strong><br/>
      If a client chooses to not include a condition in their offer, it is important 
      to ensure they understand the risks and are comfortable with the potential 
      consequences. Furthermore, ensure you complete FORM 127 for situations where 
      your clients choose to not include a recommended condition in the offer.
      <br/><br/>
      Review the <a
      href="/SK/transaction-checklists"
      rel="noopener noreferrer"
    >
      Transaction Checklists</a> section to view & better understand common 
      conditions and how they may apply to your client's specific needs for this 
      type of transaction.<br/><br/>

      <strong>Buyer Lawyer Review Condition</strong><br/>
      This is a very important condition to include in the offer, as it will give 
      the opportunity to review the transaction with a lawyer. Based on the unique 
      circumstances of the transaction, the lawyer may recommend additional conditions 
      or clauses to be included in the offer. Additionally, the lawyer can review the 
      vacant possession condition noted below.
      <br/><br/>
  
      <strong>Vacant Possession Condition</strong><br/>
      The Buyer hereby authorizes and directs the Seller, and the Seller agrees, 
      when this Agreement becomes unconditional, to give the tenant(s) the requisite 
      notices under the existing Residential Tenancies Act (RTA), requiring vacant 
      possession of the property effective _________________(closing date).  The 
      Seller further agrees to provide to the Buyer copies of the requisite notices 
      sent to, received by, and acknowledged by the tenant in this regard.  In the 
      event that the Tenant fails to vacate the property on or 
      before _________________ (closing date),  the Buyer shall have the option, in 
      the Buyer's sole and absolute discretion, to extend the Closing Date set 
      herein up to thirty (30) business days in order to obtain vacant possession set 
      out in this agreement, failing which, the Buyer shall have the option, in the 
      Buyer's sole and absolute discretion, to terminate the transaction, and the 
      deposit shall be returned to the Buyer in full forthwith, without deduction.
      <br/><br/>
      This offer is conditional upon the Seller obtaining a signed N11 agreement 
      from the Tenant of the Property to vacate no later than (Insert Date). Unless 
      the Seller gives notice in writing delivered to the Buyer not later than 
      (Insert Date), that this condition is fulfilled, this Offer shall be null and 
      void and the deposit shall be returned to the Buyer in full without deduction. 
      This condition is included for the benefit of the Buyer and may be waived at 
      the Buyer's sole option by notice in writing to the Seller within the time 
      period stated herein.
      <br/><br/>

      Explanation of the above Condition:<br/>
      This clause ensures the Seller is responsible for giving the tenant proper 
      notice to vacate under the Residential Tenancies Act and must provide the 
      Buyer with proof of those notices and any tenant acknowledgments. If the 
      tenant does not vacate by closing, the Buyer can either extend the closing 
      by up to 30 business days or terminate the agreement and receive a full 
      refund of the deposit. The offer is also conditional on the Seller securing 
      a signed N11 - Agreement to End Tenancy by a specific date. If this 
      condition isn't met, the Buyer can cancel the deal without penalty. The 
      10-day extension allows the Seller time to file an L3 application to obtain 
      an expedited eviction order from the Landlord and Tenant Board (LTB). As long 
      as proper procedures have been followed, the LTB will issue the order without 
      a hearing.
        `,
      },
    ],
  },
  {
    type: "transaction topic",
    id: "cottage",
    title: "Cottage Property",
    description: `<p>
    Review the Single Family Residential (Resale) section, as many of those 
    considerations will apply to this scenario as well. For cottage properties, 
    here are some additional items to consider.
    <br/><br/>
    Purchasing a cottage typically involves acquiring a seasonal or year-round 
    recreational property, often in rural or remote areas, with unique considerations 
    not typically encountered in urban residential transactions. Buyers must evaluate 
    a multitude of factors such as property access, services, shoreline rights, 
    septic and well systems, and local bylaws.
    <br/><br/>
    REALTORS® must guide clients through the complexities of rural ownership, 
    environmental protections, and seasonal occupancy restrictions. Due diligence is 
    essential to ensure a smooth and informed transaction.
    <br/><br/>
    Every transaction/property is unique, and the guidance provided may not address all 
    situations. REALTORS® are expected to perform proper due diligence and advocate  
    for their clients, in line with professional standards. If it's your first time 
    handling this type of deal, working with a more experienced REALTOR® is strongly 
    recommended—not only to protect your client's best interests and ensure 
    competent service, but also to benefit from the opportunity to learn from their 
    experience.
    </p>
    `,
    text: [
      {
        title: "Common Due Diligences",
        text: `
        <strong>Seasonal vs. Year-Round Use</strong><br/>
        Cottages may be designated for seasonal use only and lack year-round access or 
        infrastructure (e.g., winterized plumbing, heating, road access/maintenance).
        <br/><strong class="bold">Action:</strong> Review zoning bylaws and official 
        plan designations. Ask the municipality whether the property permits 
        year-round occupancy and whether road access/maintenance is provided year-round.
        <br/><br/>
  
        <strong>Access Type</strong><br/>
        Access may be municipal (maintained roads), private (shared maintenance), or 
        water-access only (boat-in).
        <br/><strong class="bold">Action:</strong> Confirm legal access via survey or 
        title search. Review road maintenance agreements for private access roads.  
        The property may have a shared maintenance agreement with other properties in 
        the area.
        <br/><br/>
  
        <strong>Shoreline Ownership and Rights</strong><br/>
        Determine whether the waterfront is privately owned, crown-owned, or has a 
        shore road allowance (SRA).
        <br/><strong class="bold">Action:</strong> Confirm with land registry whether 
        the shoreline is owned or leased. Check for ability to install or maintain a 
        dock, boathouse, or waterfront structure. Consult the local Conservation 
        Authority for any restrictions on shoreline alterations.
        <br/><br/>
  
        <strong>Water Source and Quality</strong><br/>
        Cottage water may come from a lake, river, well, or cistern and may not be 
        potable.
        <br/><strong class="bold">Action:</strong> Conduct potability tests and confirm 
        system details (e.g., filtration, UV treatment). Ask when water is typically 
        turned off for winter. If a well is present, it is possible that it is shared 
        with other properties in the area. Confirm with the Listing Agent/Seller and 
        obtain any shared well agreements, if applicable.
        <br/><br/>
  
        <strong>Septic System or Holding Tank</strong><br/>
        Many cottages rely on private septic systems, which must be inspected and in 
        good condition.
        <br/><strong class="bold">Action:</strong> Request septic inspection and system 
        records. Verify municipal requirements for upgrades or pump-out schedules.
        <br/><br/>
  
        <strong>Heating, Insulation & Winterization</strong><br/>
        Heating may be electric baseboard, propane, or wood stove. Older cottages may 
        lack proper insulation or winter-proofing.
        <br/><strong class="bold">Action:</strong> Confirm heating system type, age, 
        and suitability for year-round use. Assess the risk of frozen pipes or 
        seasonal damage. Inquire with the Listing Agent/Seller for any winterization 
        practices they have in place.
        <br/><br/>
  
        <strong>Environmental Regulations and Conservation Authority</strong><br/>
        Cottages near lakes or wetlands may fall under jurisdiction of a Conservation 
        Authority or have protected shoreline restrictions.
        <br/><strong class="bold">Action:</strong> Check with the relevant conservation 
        authority for restrictions on tree removal, shoreline alteration, docks, and 
        additions.
        <br/><br/>
  
        <strong>Local Amenities and Emergency Services</strong><br/>
        Remote locations may have limited emergency access, cell coverage, or 
        convenience services.
        <br/><strong class="bold">Action:</strong> Discuss with the Buyer their 
        expectations and needs (hospital proximity, internet, boat launch, garbage 
        collection, etc.).
        `,
      },
      {
        title: "Financing & Appraisal",
        text: `
        <strong>Mortgage Challenges</strong><br/>
        Financing seasonal properties or water-access-only cottages may require 
        specialized lenders or larger down payments. It is common that a minimum of 
        20% down payment is required for these types of properties.
        <br/><strong class="bold">Action:</strong> Connect clients early with a 
        mortgage broker familiar with rural and recreational property lending.
        <br/><br/>
  
        <strong>Appraisals for Unique Properties</strong><br/>
        Appraisals can be difficult if few comparable properties exist, especially on 
        islands or with irregular features.
        <br/><strong class="bold">Action:</strong> Work with lenders to support the 
        appraisal and prepare your client for potential value discrepancies.
        <br/><br/>
  
        <strong>Insurance Availability</strong><br/>
        Insuring remote or seasonal cottages can be challenging due to wood stoves, 
        limited access, or proximity to water.
        <br/><strong class="bold">Action:</strong> Obtain a quote early and confirm 
        insurance is available and affordable before fulfilling the conditions.
        `,
      },
      {
        title: "Additional Common Questions",
        text: `
        <ol>
        <li>Is the property designated seasonal or year-round?</li>
        <li>Is road access maintained in winter?</li>
        <li>Who owns the shoreline, and can I make changes to it?</li>
        <li>What are the source and quality of the water supply?</li>
        <li>When was the septic system installed and last serviced?</li>
        <li>What heating source is used, and is it adequate for winter?</li>
        <li>Are there any building or shoreline restrictions from conservation 
        authorities?</li>
        <li>What services (garbage, fire, medical) are available nearby?</li>
        <li>Is cell phone and internet coverage available at the property?</li>
        </ol>
        `,
      },
      {
        title: "Offer Practices & Conditions/Clauses",
        text: `
        <strong>Offer Best Practices</strong><br/>
      <ol>
      <li>"Time is of the essence" when it comes to agreements. Make sure that 
      agreements and related deal documents are signed within their designated 
      time frames.</li>
      <li>Confirm that all OREA forms and clauses used are both current and 
      appropriate for the specific deal.</li>
      <li>Check the MLS Listing for any supplemental documents to be included with 
      the offer.</li>
      <li>Deposit delivery must occur within the specified time frame on the agreement. 
      If the deposit isn't delivered, the client is in breach and may face legal 
      action. </li>
      <li>Always assign a firm date to conditions and clauses. Phrases like "5 
      business days" can cause confusion and conflict. A set deadline makes 
      expectations clear for everyone involved.</li>
      </ol>

      <br/>
      <strong>Conditions & Clauses</strong><br/>
      If a client chooses to not include a condition in their offer, it is important 
      to ensure they understand the risks and are comfortable with the potential 
      consequences. Furthermore, ensure you complete FORM 127 for situations where 
      your clients choose to not include a recommended condition in the offer.
      <br/><br/>
      It is always best practice to include a Buyer's Lawyer Review condition in 
      the offer, especially if the property has unique characteristics that 
      require further investigation.
      <br/><br/>
      Review the <a
      href="/SK/transaction-checklists"
      rel="noopener noreferrer"
    >
      Transaction Checklists</a> section to view & better understand common 
      conditions and how they may apply to your client's specific needs for this 
      type of transaction.<br/><br/>

        `,
      },
    ],
  },
  {
    type: "transaction topic",
    id: "preconfreehold",
    title: "Pre-Construction (Freehold)",
    description: `
    Purchasing a pre-construction freehold home in Ontario — such as a detached, 
    semi-detached, or townhome — means entering into a contract to buy a newly built 
    property directly from a builder before it's completed. These transactions differ 
    from resale or pre-construction condo purchases in terms of structure, fees, and 
    closing timelines.
    <br/><br/>
    REALTORS® must help Buyers navigate builder contracts, occupancy dates, deposits, 
    and hidden costs. Legal review and clear communication around delays, warranties, 
    and municipal approvals are essential to protect the Buyer's investment and 
    expectations.
    `,
    text: [
      {
        title: "Common Due Diligences",
        text: `
        <strong>Firm Closing vs. Tentative Timelines</strong><br/>
        Pre-construction freeholds typically don't have interim occupancy like condos, 
        but the final closing date is often tentative and may change.
        <br/><strong class="bold">Action:</strong> Review all builder documents for 
        language about extension rights and critical dates. Prepare clients for 
        potential delays in closing.
        <br/><br/>
  
        <strong>HST and Rebate Clarification</strong><br/>
        HST is typically included in advertised prices, but Buyers must qualify for 
        the New Home Rebate if they intend to live in the property.
        <br/><strong class="bold">Action:</strong> Confirm whether the builder or 
        Buyer is applying for the rebate and explain consequences if the Buyer is
        an investor. Have the client consult their lawyer/tax accountant to confirm 
        any HST implications.
        <br/><br/>
  
        <strong>Deposit Structure</strong><br/>
        Deposits are usually paid in installments (e.g., 5% at signing, 5% in 60 days).
        <br/><strong class="bold">Action:</strong> Review the payment schedule with the 
        Buyer to ensure they have access to funds as required.
        <br/><br/>
  
        <strong>Development Charges and Closing Costs</strong><br/>
        Freehold homes often come with uncapped development charges and levies.
        <br/><strong class="bold">Action:</strong> Negotiate caps on these fees where 
        possible and clarify all potential closing adjustments upfront.
        <br/><br/>
  
        <strong>Driveways, Landscaping, and Grading</strong><br/>
        Exterior features like driveways, sod, fences, or grading may not be complete 
        on closing.
        <br/><strong class="bold">Action:</strong> Confirm with the builder what will 
        be completed at occupancy and what may be delayed until seasonal conditions 
        permit.
        <br/><br/>
  
        <strong>Builder Reputation and Track Record</strong><br/>
        The quality and consistency of the builder can affect timelines, finish quality, 
        and service after closing.
        <br/><strong class="bold">Action:</strong> Research the builder's past projects, 
        online reviews, and Tarion record (warranty history and disputes).
        <br/><br/>
  
        <strong>Tarion Warranty Program</strong><br/>
        New freehold homes are covered under the Tarion New Home Warranty, offering 
        protection for up to 7 years.
        <br/><strong class="bold">Action:</strong> Explain the warranty coverage and 
        key deadlines (e.g., 30-day, 1-year, 2-year, and 7-year claims).
        `,
      },
      {
        title: "Financing & Construction Considerations",
        text: `
        <strong>Mortgage Pre-Approval Limitations</strong><br/>
        Most lenders won't finalize a mortgage more than 120 days before closing.
        <br/><strong class="bold">Action:</strong> Encourage clients to obtain 
        pre-qualification now and revisit full approval closer to closing.
        <br/><br/>
  
        <strong>Construction Delays and Critical Dates</strong><br/>
        Builders may legally extend the construction timeline under Tarion's critical 
        date framework.
        <br/><strong class="bold">Action:</strong> Review Tarion's Addendum and explain 
        Firm, Tentative, and Outside Closing Dates.
        <br/><br/>
  
        <strong>Appraisal at Time of Closing</strong><br/>
        The lender will typically require an appraisal close to closing to ensure the 
        value matches the purchase price.
        <br/><strong class="bold">Action:</strong> Advise Buyers of possible appraisal 
        shortfalls and the need for a financing buffer.
        `,
      },
      {
        title: "Additional Common Questions",
        text: `
        <ol>
        <li>What is the current construction status and projected closing date?</li>
        <li>Are development charges and levies capped in the agreement?</li>
        <li>What finishes are standard vs. upgrades?</li>
        <li>Is HST included in the purchase price, and who is claiming the rebate?</li>
        <li>Will the driveway, sod, or grading be completed before closing?</li>
        <li>Are there any known delays in permits, servicing, or municipal approvals?</li>
        <li>What builder warranties and after-sale services are included?</li>
        <li>What are the builder's policies on assignment or alterations?</li>
        <li>Is the home registered under the Tarion Warranty Program?</li>
        </ol>
        `,
      },
      {
        title: "Common Conditions and Clauses",
        text: `
        <p>
        <strong>10-Day Cooling-Off Period (Builder-Dependent)</strong><br/>
        While not required by law for freehold homes (unlike condos), some builders 
        offer this. Always check the contract.
        <br/><br/>
  
        <strong>Lawyer Review Condition</strong><br/>
        Critical due to the complexity of builder APS agreements and Tarion Addendum.
        <br/><br/>
  
        <strong>Financing Condition</strong><br/>
        Provides time for Buyers to confirm affordability and mortgage terms.
        <br/><br/>
  
        <strong>Closing Cost Cap Clause</strong><br/>
        If not already included, negotiate a clause limiting the Buyer's exposure to 
        development charges and builder fees.
        <br/><br/>
  
        <strong>Other Useful Clauses and Considerations</strong>
        <ol>
          <li>HST clause specifying responsibility for rebate qualification</li>
          <li>Assignment clause (if allowed) outlining fees and timelines</li>
          <li>Confirmation of Tarion registration and warranty enrollment</li>
          <li>Upgrade list review and confirmation of selections</li>
          <li>Builder walkthrough or deficiency inspection rights prior to closing</li>
        </ol>
        </p>
        `,
      },
    ],
  },
  {
    type: "transaction topic",
    id: "indigenousLand",
    title: "Purchase on Reserve Land (Leased Land)",
    description: `<p>
    Purchasing property on Indigenous (First Nations) lands is significantly 
    different from traditional freehold or condominium transactions. Most properties 
    located on reserve land are not owned in fee simple but instead fall under federal 
    jurisdiction via the <em>Indian Act</em>. Buyers typically acquire leasehold 
    interests through band council-approved arrangements, with additional oversight 
    by Indigenous Services Canada.
    <br/><br/>
    REALTORS® must understand the legal and financial frameworks that govern reserve 
    land transactions, including lease terms, community consent, lender requirements, 
    and restrictions on resale or development. Legal counsel and mortgage brokers 
    familiar with Indigenous land structures are critical to protecting Buyer 
    interests.
    <br/><br/>
    Every transaction/property is unique, and the guidance provided may not address all 
    situations. REALTORS® are expected to perform proper due diligence and advocate  
    for their clients, in line with professional standards. If it's your first time 
    handling this type of deal, working with a more experienced REALTOR® is strongly 
    recommended—not only to protect your client's best interests and ensure 
    competent service, but also to benefit from the opportunity to learn from their 
    experience.
    </p>
    `,
    text: [
      {
        title: "Common Due Diligences",
        text: `
        Review the Single Family Residential (Resale) section, as many of those  
        considerations will apply to this scenario as well. 
        For properties on reserve land, here are some additional items to consider.
        <br/><br/>

        <strong>Ownership Structure: Leasehold vs. Freehold</strong><br/>
        Most real estate on reserve land is not sold in fee simple. Instead, 
        non-Indigenous Buyers may obtain leasehold interests approved by the First 
        Nation and Indigenous Services Canada.
        <br/><strong class="bold">Action:</strong> Determine whether the land is on a 
        designated reserve, whether a lease exists, and the remaining term of the 
        lease.  
        <br/><br/>
  
        <strong>Band Council and ISC Approval</strong><br/>
        Transactions typically require approval from the local First Nation's Band 
        Council and the federal government (Indigenous Services Canada).
        <br/><strong class="bold">Action:</strong> Engage early with the Band Council 
        or land management office to understand the approval process and timing.
        <br/><br/>
  
        <strong>Land Management Regime (MATR or FNLMA)</strong><br/>
        Some First Nations operate under the <em>First Nations Land Management Act</em> 
        (FNLMA), giving them authority to manage land independently of the Indian Act.
        <br/><strong class="bold">Action:</strong> Ask whether the community operates 
        under the Indian Act or FNLMA, as this affects rules for leasing, mortgages, 
        and resale.
        <br/><br/>
  
        <strong>Length and Conditions of Lease</strong><br/>
        Leasehold terms typically range from 25 to 99 years, often with renewal 
        clauses, rent escalation terms, and restrictions on property use or 
        modifications.
        <br/><strong class="bold">Action:</strong> Review the lease agreement in 
        detail with a lawyer familiar with federal leasehold transactions.
        <br/><br/>
  
        <strong>Community Rules, Bylaws & Infrastructure</strong><br/>
        Communities may impose their own bylaws for development, noise, septic systems, 
        and occupancy.
        <br/><strong class="bold">Action:</strong> Clarify with the Band Council or 
        property manager any relevant regulations, service limitations, or 
        infrastructure constraints.
        <br/><br/>
  
        <strong>Resale and Inheritance Restrictions</strong><br/>
        Resale of properties on reserve land may be restricted to eligible Buyers or 
        require Band approval. Leaseholds may not be transferrable without consent.
        <br/><strong class="bold">Action:</strong> Ensure the Buyer is aware of 
        assignment and resale limitations, especially for investment or long-term 
        family planning.
        `,
      },
      {
        title: "Financing, Legal, and Insurance",
        text: `
        <strong>Financing Challenges on Reserve Land</strong><br/>
        Most conventional lenders are unwilling to finance properties on reserve 
        land, making it harder for buyers to secure a mortgage.
        <br/><strong class="bold">Action:</strong> Encourage your client to consult 
        a mortgage broker who specializes in this type of financing. They can help 
        navigate lender requirements and confirm whether the leasehold property is 
        eligible for mortgage approval.
        <br/><br/>
  
        <strong>Title and Leasehold Interest</strong><br/>
        Title is often held in trust by the Crown (Gov't of Canada). Buyers hold a 
        leasehold interest rather than full ownership.
        <br/><strong class="bold">Action:</strong> Ensure legal counsel explains the 
        structure of the interest and confirms enforceability.
        <br/><br/>
  
        <strong>Insurance and Risk Considerations</strong><br/>
        Insuring properties on reserve land may require additional documentation 
        and approval from both insurer and Band.
        <br/><strong class="bold">Action:</strong> Obtain insurance quotes early and 
        verify eligibility with underwriters who support leasehold or rural 
        properties.
        `,
      },
      {
        title: "Additional Common Questions",
        text: `
        <ol>
        <li>Is the property located on a designated reserve or settlement land?</li>
        <li>What is the term and remaining duration of the lease?</li>
        <li>Are there restrictions on resale or inheritance?</li>
        <li>What approvals are required from the Band Council or ISC?</li>
        <li>What bylaws or community rules govern development and occupancy?</li>
        <li>Are utilities, roads, and emergency services municipally supported or 
        community-managed?</li>
        <li>Can your client obtain mortgage financing and home insurance for this 
        property?</li>
        <li>Is the lease registered with Indigenous Services Canada (ISC)?</li>
        <li>Are there land claim issues or disputes involving this area?</li>
        </ol>
        `,
      },
      {
        title: "Offer Practices & Conditions/Clauses",
        text: `
       <strong>Offer Best Practices</strong><br/>
      <ol>
      <li>"Time is of the essence" when it comes to agreements. Make sure that 
      agreements and related deal documents are signed within their designated 
      time frames.</li>
      <li>Confirm that all OREA forms and clauses used are both current and 
      appropriate for the specific deal.</li>
      <li>Check the MLS Listing for any supplemental documents to be included with 
      the offer.</li>
      <li>Deposit delivery must occur within the specified time frame on the agreement. 
      If the deposit isn't delivered, the client is in breach and may face legal 
      action. </li>
      <li>Always assign a firm date to conditions and clauses. Phrases like "5 
      business days" can cause confusion and conflict. A set deadline makes 
      expectations clear for everyone involved.</li>
      </ol>

      <br/>
      <strong>Conditions & Clauses</strong><br/>
      If a client chooses to not include a condition in their offer, it is important 
      to ensure they understand the risks and are comfortable with the potential 
      consequences. Furthermore, ensure you complete FORM 127 for situations where 
      your clients choose to not include a recommended condition in the offer.
      <br/><br/>
      It is always best practice to include a Buyer's Lawyer Review condition in 
      the offer, especially if the property has unique characteristics that 
      require further investigation.
      <br/><br/>
      Review the <a
      href="/SK/transaction-checklists"
      rel="noopener noreferrer"
    >
      Transaction Checklists</a> section to view & better understand common 
      conditions and how they may apply to your client's specific needs for this 
      type of transaction.<br/><br/>

       <strong>Common Conditions/Clauses worth noting for this type of transaction:</strong><br/>
      <ol>
      <li>Band Council Approval Condition: Make the offer conditional upon receiving 
      written approval from the local Band Council for lease transfer or Buyer 
      eligibility</li>
      <li>Indigenous Services Canada Approval: If applicable, include a clause 
      requiring federal approval before deal can close</li>
      <li>Lawyer Review Condition: Legal review is essential for any leasehold 
      arrangement, land use rules, or  lease clauses</li>
      <li>Review of Land Lease: Review the land lease agreement, rights, and 
      obligations</li>
       <li>Insurance availability and premium confirmation</li>
       <li>Review of land use bylaws or building restrictions</li>
      </ol>
      <br/>
  
      
      
        `,
      },
    ],
  },
  {
    type: "transaction topic",
    id: "mobileManufactured",
    title: "Mobile, Manufactured, and Modular Home",
    description: `<p>
    Purchasing a mobile, manufactured, or modular home requires a unique 
    understanding of construction types, land ownership structures, and regulatory 
    compliance. These homes may be located on leased land (in mobile home parks or 
    land lease communities), or on privately owned lots with full title.
    <br/><br/>
    REALTORS® must help Buyers differentiate between these housing types, assess 
    financing eligibility, confirm land tenure, and understand the applicable building 
    and zoning standards. Attention to detail in disclosures, insurance, and 
    construction certification is critical to protect the Buyer.
    </p>
    `,
    text: [
      {
        title: "Common Due Diligences",
        text: `
        <p>
        <strong>Mobile vs. Manufactured vs. Modular</strong><br/>
        These terms are often used interchangeably but have distinct meanings:
        <br/>
        <strong>Mobile:</strong> Older homes (often pre-1976) built to outdated 
        standards, typically on a steel frame with wheels, not always 
        CSA-certified.<br/>
        <strong>Manufactured:</strong> Factory-built homes conforming to CSA Z240 
        standards, often placed in land lease communities or mobile parks.<br/>
        <strong>Modular:</strong> Factory-built sections assembled on-site, built 
        to CSA A277 or Ontario Building Code standards. Often indistinguishable 
        from site-built homes once installed.<br/>
        <strong class="bold">Action:</strong> Confirm the build type and CSA 
        certification label on the unit. Request builder documentation if available.
        <br/><br/>
  
        <strong>Land Ownership vs. Land Lease</strong><br/>
        Some homes are situated on land owned by the Buyer, while others sit on 
        leased land with monthly park or lot fees.
        <br/><strong class="bold">Action:</strong> Clarify whether the Buyer is 
        acquiring both the home and the land (freehold) or just the structure on 
        leased land. Review the lease terms.
        <br/><br/>
  
        <strong>Park or Land Lease Community Rules</strong><br/>
        Land lease communities often have strict rules regarding occupancy, 
        maintenance, pets, and resale.
        <br/><strong class="bold">Action:</strong> Obtain and review the park's rules, 
        site lease, and transfer policies before firming up the offer.
        <br/><br/>
  
        <strong>Zoning and Bylaw Compliance</strong><br/>
        Some municipalities restrict mobile or manufactured homes in certain zones.
        <br/><strong class="bold">Action:</strong> Verify with the municipality that 
        the property complies with local zoning and building regulations.
        <br/><br/>
  
        <strong>Utilities and Infrastructure</strong><br/>
        Ensure the property has reliable access to water, hydro, septic or sewer, and 
        heating (propane, electric, etc.).
        <br/><strong class="bold">Action:</strong> Confirm utility hookups and 
        inquire about service fees and past disruptions.
        <br/><br/>
  
        <strong>Age and Condition</strong><br/>
        Older mobile homes may not meet modern safety or lending standards.
        <br/><strong class="bold">Action:</strong> Order a qualified inspection and 
        verify that the unit meets safety, insulation, and electrical standards.
        </p>
        `,
      },
      {
        title: "Financing & Appraisal",
        text: `
        <strong>Mortgage Financing Challenges</strong><br/>
        Homes not on owned land or not on a permanent foundation may not qualify 
        for traditional mortgages.
        <br/><strong class="bold">Action:</strong> Connect the Buyer with a mortgage 
        broker familiar with manufactured and land lease financing.
        <br/><br/>
  
        <strong>CSA Certification & Lender Requirements</strong><br/>
        Many lenders require CSA certification (Z240 for manufactured, A277 for modular) and proof of permanent anchoring.
        <br/><strong class="bold">Action:</strong> Confirm the CSA number and ensure installation was completed per standards.
        <br/><br/>
  
        <strong>Insurance Availability</strong><br/>
        Older or unanchored mobile homes may be difficult or costly to insure.
        <br/><strong class="bold">Action:</strong> Obtain an insurance quote early, 
        and clarify whether coverage includes the structure, contents, and liability.
        <br/><br/>
  
        <strong>Title and Ownership Documents</strong><br/>
        Depending on the age and location, the home may be treated as chattel 
        (personal property) or as real property.
        <br/><strong class="bold">Action:</strong> Confirm legal ownership, land 
        registry status, and whether the property is taxed as real estate or 
        personal property.
        `,
      },
      {
        title: "Additional Common Questions",
        text: `
        <ol>
        <li>What type of home is it: mobile, manufactured, or modular?</li>
        <li>Is the home CSA certified, and what is the certification type?</li>
        <li>Is the land included in the purchase?</li>
        <li>What are the park or lease fees, and what do they include?</li>
        <li>What utilities are available and who are the service providers?</li>
        <li>Are there age or use restrictions within the community?</li>
        <li>Are pets or rentals allowed in the park?</li>
        <li>Can I secure mortgage financing or must I pay cash?</li>
        <li>Are there resale or transfer restrictions set by the park owner?</li>
        </ol>
        `,
      },
      {
        title: "Offer Practices & Conditions/Clauses",
        text: `
         <strong>Offer Best Practices</strong><br/>
      <ol>
      <li>"Time is of the essence" when it comes to agreements. Make sure that 
      agreements and related deal documents are signed within their designated 
      time frames.</li>
      <li>Confirm that all OREA forms and clauses used are both current and 
      appropriate for the specific deal.</li>
      <li>Check the MLS Listing for any supplemental documents to be included with 
      the offer.</li>
      <li>Deposit delivery must occur within the specified time frame on the agreement. 
      If the deposit isn't delivered, the client is in breach and may face legal 
      action. </li>
      <li>Always assign a firm date to conditions and clauses. Phrases like "5 
      business days" can cause confusion and conflict. A set deadline makes 
      expectations clear for everyone involved.</li>
      </ol>

      <br/>
      <strong>Conditions & Clauses</strong><br/>
      If a client chooses to not include a condition in their offer, it is important 
      to ensure they understand the risks and are comfortable with the potential 
      consequences. Furthermore, ensure you complete FORM 127 for situations where 
      your clients choose to not include a recommended condition in the offer.
      <br/><br/>
      It is always best practice to include a Buyer's Lawyer Review condition in 
      the offer, especially if the property has unique characteristics that 
      require further investigation.
      <br/><br/>
      Review the <a
      href="/SK/transaction-checklists"
      rel="noopener noreferrer"
    >
      Transaction Checklists</a> section to view & better understand common 
      conditions and how they may apply to your client's specific needs for this 
      type of transaction.<br/><br/>

      <strong>Common Conditions/Clauses worth noting for this type of transaction:</strong><br/>
      <ol>
      <li>Financing Condition: Especially critical if the property is in a land 
      lease community or lacks a traditional foundation</li>
      <li>Lawyer Review of Lease or Park Rules: Essential for leasehold purchases 
      to review the lot lease agreement, rights, and obligations</li>
      <li>Insurance availability and premium confirmation</li>
      </ol>
      <br/>
        `,
      },
    ],
  },
  {
    type: "transaction topic",
    id: "crownLand",
    title: "Purchase on Crown Land (Leased Land)",
    description: `
    Purchasing a residential property on Crown Land in Ontario involves acquiring a 
    structure or leasehold interest on land that is owned and managed by the 
    provincial or federal government. Buyers must understand that Crown land cannot be 
    privately owned in most cases, and transactions typically involve leasehold 
    arrangements governed by strict rules, renewal conditions, and development 
    restrictions.
    <br/><br/>
    REALTORS® must ensure Buyers understand the limitations of Crown land ownership, 
    legal implications of leasehold tenure, and the risks associated with financing, 
    resale, and land use. Legal counsel and early contact with the appropriate 
    government authority are essential.
    `,
    text: [
      {
        title: "Common Due Diligences",
        text: `
        <strong>Ownership Limitations</strong><br/>
        Crown Land is owned by the provincial or federal government and cannot be 
        purchased outright. Residential use is usually granted through long-term leases, 
        licenses of occupation, or permits.
        <br/><strong class="bold">Action:</strong> Confirm the type of tenure involved 
        (lease, permit, license) and the length, renewal terms, and conditions of use.
        <br/><br/>
  
        <strong>Government Authority and Oversight</strong><br/>
        In Ontario, Crown land is typically managed by the Ministry of Natural Resources 
        and Forestry (MNRF) or Parks Canada (in federal territories).
        <br/><strong class="bold">Action:</strong> Contact MNRF or the relevant federal 
        agency to verify the lease's legitimacy, current standing, and any pending 
        changes.
        <br/><br/>
  
        <strong>Lease Conditions and Restrictions</strong><br/>
        Lease agreements may prohibit year-round use, restrict renovations, or limit 
        resale/transfer rights.
        <br/><strong class="bold">Action:</strong> Carefully review the lease terms with 
        a real estate lawyer. Confirm usage rights, seasonal restrictions, and 
        requirements for maintaining the property.
        <br/><br/>
  
        <strong>Transferability and Sale Approvals</strong><br/>
        Transfers of leasehold interests on Crown land often require government approval 
        and may be delayed or denied depending on lease terms or policy changes.
        <br/><strong class="bold">Action:</strong> Request all current lease documents 
        and confirm transfer procedures with the managing authority.
        <br/><br/>
  
        <strong>Improvements and Permits</strong><br/>
        Any development, alteration, or expansion may require additional approvals from 
        the Crown or environmental authorities.
        <br/><strong class="bold">Action:</strong> Ensure all existing improvements were 
        permitted. Review policies on adding docks, septic systems, solar panels, or 
        boathouses.
        <br/><br/>
  
        <strong>Environmental Sensitivity and Conservation Policies</strong><br/>
        Crown lands often include protected shorelines, wetlands, or wildlife corridors 
        with strict development controls.
        <br/><strong class="bold">Action:</strong> Inquire about environmental 
        assessments, local conservation authority jurisdiction, and protected species 
        restrictions.
        `,
      },
      {
        title: "Financing, Legal, and Insurance Considerations",
        text: `
        <strong>Mortgage Financing Limitations</strong><br/>
        Most lenders do not provide traditional mortgages for properties on Crown land, 
        especially where the Buyer does not hold title to the land.
        <br/><strong class="bold">Action:</strong> Prepare Buyers for cash purchases or 
        limited lending options through private lenders or lines of credit.
        <br/><br/>
  
        <strong>Title vs. Leasehold Interest</strong><br/>
        The Buyer is not acquiring legal title to the land, but rather a lease or 
        license to use it. These rights may be time-limited or non-renewable.
        <br/><strong class="bold">Action:</strong> Work with legal counsel to ensure the 
        interest is assignable and valid for the intended use.
        <br/><br/>
  
        <strong>Insurance Challenges</strong><br/>
        Insurance for buildings on Crown land may be harder to obtain due to access, 
        remoteness, or unclear land tenure.
        <br/><strong class="bold">Action:</strong> Engage an insurer early and verify 
        property risk factors (e.g., seasonal access, emergency response times).
        `,
      },
      {
        title: "Additional Common Questions",
        text: `
        <ol>
        <li>Is the land owned by the Buyer or leased from the Crown?</li>
        <li>What is the term of the lease, and can it be renewed?</li>
        <li>Are there any use restrictions (seasonal vs. full-time use)?</li>
        <li>What is the process for transferring or assigning the lease?</li>
        <li>Are there rules governing improvements, renovations, or new construction?</li>
        <li>Can the property be mortgaged or must it be purchased in cash?</li>
        <li>What services (hydro, water, septic) are available and permitted?</li>
        <li>Is there any risk that the lease will not be renewed or will be revoked?</li>
        <li>Are there environmental protections or conservation restrictions on the property?</li>
        </ol>
        `,
      },
      {
        title: "Common Conditions and Clauses",
        text: `
        <p>
        <strong>Legal Review of Lease or License Agreement</strong><br/>
        Essential due to the unique nature of Crown land transactions.
        <br/><br/>
  
        <strong>Government Approval of Transfer Condition</strong><br/>
        Include a clause stating that the transaction is conditional upon receiving 
        transfer or assignment approval from the Crown (or relevant agency).
        <br/><br/>
  
        <strong>Insurance Condition</strong><br/>
        Confirm that insurability of the structure is feasible prior to closing.
        <br/><br/>
  
        <strong>Financing Clause (if applicable)</strong><br/>
        If financing is being pursued, make it conditional on lender approval of 
        leasehold interest and associated risks.
        <br/><br/>
  
        <strong>Other Potential Clauses</strong>
        <ol>
          <li>Review and approval of lease terms within a set timeframe</li>
          <li>Verification of environmental compliance and approvals</li>
          <li>Confirmation that all improvements were authorized by the Crown</li>
          <li>Disclosure of lease payment schedule and obligations</li>
          <li>Right to terminate if lease is non-transferable or expiring soon</li>
        </ol>
        </p>
        `,
      },
    ],
  },
  {
    type: "transaction topic",
    id: "ruralCountry",
    title: "Rural & Country Properties",
    description: `<p>
      Purchasing rural or country property in Ontario often involves systems and considerations
      that differ from urban and suburban homes—private wells and septic systems, larger acreages,
      outbuildings, private/seasonal roads, and proximity to agricultural uses.
      <br/><br/>
      Diligence must extend beyond the dwelling to include land use permissions, access, services,
      and environmental features. Client goals (hobby farm, privacy, hunting, short-term rental,
      future severance, home business, etc.) should be clarified early and revisited as new
      information emerges during showings and investigations.
      <br/><br/>
      Every rural property is unique. REALTORS® should perform thorough due diligence and advocate
      for their clients in line with professional standards. If this is your first rural deal,
      collaborate with an experienced REALTOR® and ensure the client’s lawyer is familiar with rural
      transactions.
    </p>`,
    text: [
      {
        title: "Common Due Diligences",
        text: `
        Review the Single Family Residential (Resale) section, as many of those 
        considerations will apply to this scenario as well. 
        Here are some extra things to consider specifically when it comes to 
        country/rural properties.
        <br/><br/>
        <strong>Private Water Wells</strong><br/>
        Identify well type (drilled/dug), location, age, depth, flow rate, and treatment equipment.
        Confirm potable water and review well records if available.
        <br/><strong class="bold">Action:</strong> Include water potability and flow-rate testing in conditions.
        Request recent test results and any service/maintenance records for pumps and treatment systems.
        <br/><br/>
  
        <strong>Septic Systems</strong><br/>
        Determine system type, age, capacity, location of tank and bed, and permit history.
        Look for signs of failure or improper siting near wells or waterways.
        <br/><strong class="bold">Action:</strong> Include a septic inspection/pump-out confirmation.
        Ask for receipts, permits, and as-built diagrams. Ensure access lids are visible and safe.
        <br/><br/>
  
        <strong>Heating, Power & Solid-Fuel Appliances</strong><br/>
        Common heating includes propane, oil, electric, heat pumps, and wood/pellet stoves.
        Verify tank ownership (rental vs owned), age and compliance; check for generators and transfer switches.
        Wood-burning units may require WETT inspections for insurance.
        <br/><strong class="bold">Action:</strong> Confirm fuel contracts/rentals to assume or buy out.
        Include WETT and fuel-tank compliance conditions where applicable.
        <br/><br/>
  
        <strong>Internet, Cell & Utilities</strong><br/>
        Service may be limited. Confirm available internet (fibre, fixed wireless, satellite) and cell coverage.
        Check hydro reliability and known outage frequency.
        <br/><strong class="bold">Action:</strong> Ask sellers for providers, typical speeds, and any known issues.
        <br/><br/>
  
        <strong>Access: Roads, Driveways & Maintenance</strong><br/>
        Clarify if access is municipal, private, seasonal, or via right-of-way.
        Private/condo roads may require maintenance agreements; seasonal roads may not be plowed.
        <br/><strong class="bold">Action:</strong> Obtain and review any registered access/maintenance agreements.
        Verify winter access and school bus/snow removal routes.
        <br/><br/>
  
        <strong>Boundaries, Surveys & Acreage</strong><br/>
        Fences, old blazes, or tree lines may be inaccurate. Outbuildings, driveways, or fences can encroach.
        <br/><strong class="bold">Action:</strong> Request an up-to-date survey.
        Consider staking/pinning. Verify acreage and usable land (rock, wetland, steep slopes).
        <br/><br/>
  
        <strong>Zoning & Land Use Permissions</strong><br/>
        Rural properties can be zoned Rural, Agricultural, Environmental Protection, etc.
        Uses like livestock, kennels, home industries, secondary units, and short-term rentals vary by municipality.
        Minimum Distance Separation (MDS)from livestock operations can limit new buildings/additions.
        <br/><strong class="bold">Action:</strong> Confirm current and intended uses with the municipality.
        Ask specifically about MDS, home-based businesses, second dwellings, trailers, 
        and STR bylaws, if applicable.
        <br/><br/>
  
        <strong>Conservation Authorities & Setbacks</strong><br/>
        Floodplains, wetlands, shorelines, and hazard lands may restrict development or require permits.
        <br/><strong class="bold">Action:</strong> Check local Conservation Authority mapping and speak with staff
        about any planned changes (garages, additions, driveways, docks).
        <br/><br/>
  
        <strong>Environmental & Natural Features</strong><br/>
        Look for radon potential, abandoned wells, former fuel/oil use, pesticide storage, dumps, or buried debris.
        Woodlots, wetlands, species-at-risk habitat, and watercourses may carry restrictions.
        <br/><strong class="bold">Action:</strong> Ask sellers about environmental concerns and prior uses.
        Consider specialty inspections or environmental advice if red flags arise.
        <br/><br/>
  
        <strong>Outbuildings & Services</strong><br/>
        Verify permits, electrical safety, and intended uses for barns, shops, and sheds.
        Large shops may trigger zoning/occupancy considerations.
        <br/><strong class="bold">Action:</strong> Confirm hydro subpanels, heating, 
        water lines, and any commercial use, if applicable. Have the appropriate 
        inspections done based on the property.
        <br/><br/>
  
        <strong>Taxes, Programs & HST</strong><br/>
        Property class (residential vs farm) affects taxes. Programs like Managed Forest or Conservation Land Tax
        can reduce taxes but carry obligations. HST may apply to some vacant land, farm assets, or newly built structures.
        <br/><strong class="bold">Action:</strong> Have the client’s lawyer/accountant confirm tax class, program obligations,
        and HST applicability. Reflect HST treatment clearly in the offer.
        <br/><br/>
  
        <strong>Easements, Rights-of-Way & Utilities</strong><br/>
        Confirm hydro/pipeline easements, shared driveways, and any shore road allowances on waterfront parcels.
        <br/><strong class="bold">Action:</strong> Order title search/GeoWarehouse and have the lawyer review for constraints.
        <br/><br/>
  
        <strong>Agricultural Neighbours & Rural Realities</strong><br/>
        Expect noises, odours, dust, equipment traffic, and early/late farm operations protected under normal farm practices.
        <br/><strong class="bold">Action:</strong> Discuss lifestyle fit with clients and visit at different times of day.
        `,
      },
      {
        title: "Financing & Appraisal",
        text: `
        <strong>Pre-Approval & Lender Comfort</strong><br/>
        Lenders may require water potability, well flow, and septic reports. Private roads/seasonal access,
        large acreages, hobby-farm income, and extensive outbuildings can affect loan-to-value and insurability.
        <br/><strong class="bold">Action:</strong> Engage lenders early and share property specifics up front.
        Line up multiple financing options if the file is non-standard.
        <br/><br/>
  
        <strong>Appraisals in Rural Areas</strong><br/>
        Comparable sales may be scarce; excess acreage and outbuildings may receive limited contributory value.
        <br/><strong class="bold">Action:</strong> Prepare the appraiser with a detailed feature list, recent upgrades,
        and any survey or permits to support value.
        <br/><br/>
  
        <strong>Insurance Considerations</strong><br/>
        Insurers look at distance to fire hall/hydrants, solid-fuel appliances, oil tanks, and age of systems.
        <br/><strong class="bold">Action:</strong> Urge clients to obtain an insurance quote early to confirm coverage and cost.
        <br/><br/>
  
        <strong>Deposits</strong><br/>
        Similar to resale homes in other areas, deposits often range from 5–10% of purchase price, but may vary by market dynamics.
        <br/><strong class="bold">Action:</strong> Set a deposit strategy appropriate to local competition and condition timelines.
        `,
      },
      {
        title: "Additional Common Questions",
        text: `
        <ol>
          <li>Where are the well and septic located, and what are their ages/capacities?</li>
          <li>What are the most recent water potability and flow results? Who performed them?</li>
          <li>When was the septic last pumped/inspected? Any permits or drawings available?</li>
          <li>Is year-round access maintained? Who plows the road/driveway?</li>
          <li>Which internet/cell providers serve the property, and what speeds are typical?</li>
          <li>Are there conservation authority, floodplain, shoreline, or wetland constraints?</li>
          <li>Are outbuildings permitted and electrically safe? Any commercial use approvals?</li>
          <li>Do zoning and MDS rules permit my intended use (animals, shop, second unit, STRs)?</li>
          <li>Are there easements, rights-of-way, or shared drive/road agreements?</li>
          <li>Any environmental concerns (abandoned wells, old fuel tanks, dumps, radon)?</li>
          <li>Will HST apply to this purchase? Are any tax programs or farm classifications in place?</li>
          <li>Is there an up-to-date survey or evidence of property boundaries?</li>
        </ol>
        `,
      },
      {
        title: "Offer Practices & Conditions/Clauses",
        text: `
        <strong>Offer Best Practices</strong><br/> <ol> <li>"Time is of the essence" when it comes to agreements. Make sure that agreements and related deal documents are signed within their designated time frames.</li> <li>Confirm that all OREA forms and clauses used are both current and appropriate for the specific deal.</li> <li>Check the MLS Listing for any supplemental documents to be included with the offer.</li> <li>Deposit delivery must occur within the specified time frame on the agreement. If the deposit isn't delivered, the client is in breach and may face legal action. </li> <li>Always assign a firm date to conditions and clauses. Phrases like "5 business days" can cause confusion and conflict. A set deadline makes expectations clear for everyone involved.</li> </ol>
        <br/>
  
        <strong>Conditions & Clauses (Rural-Focused)</strong><br/>
        If a client elects to omit a recommended condition, ensure they understand the risks and complete FORM 127.
        It is always best practice to include a Buyer's Lawyer Review condition in the offer, especially if the property 
        has unique characteristics such as wells, septic, private roads, conservation 
        areas, or outbuildings are involved.
        <br/><br/>
        With all the various due diligences that are required for rural properties, 
        consider using a due diligence condition, in addition to the Buyer's Lawyer 
        Review condition:
        <br/><br/>
        <strong>Due Diligence Clause:</strong>
    <br/>
    This Offer is conditional upon the Buyer being able to conduct due diligence for 
    a period of _________ days from the date of acceptance of the Agreement of 
    Purchase and Sale. During this period, the Buyer shall have access to the property 
    for inspections, assessments, and investigations deemed necessary. Unless the 
    Buyer gives notice in writing delivered to the Seller personally or in accordance 
    with any other provisions for the delivery of notice in this Agreement of Purchase 
    and Sale or any Schedule, that this condition is fulfilled, this Offer shall be 
    null and void and the deposit shall be returned to the Buyer in full without 
    deduction. The Seller agrees to co-operate in providing access to the property 
    for the purpose of these investigations. This condition is included for the 
    benefit of the Buyer and may be waived at the Buyer's sole option by notice 
    in writing to the Seller as aforesaid within the time period stated herein.
    <br/> <br/>
        Additional conditions may include the following, as appropriate:
        <ol>
          <li>Any applicable clauses/conditions commonly used in Residential Transactions</li>
          <li>Water potability and well flow-rate testing; delivery of well records and treatment details.</li>
          <li>Septic inspection/pump-out confirmation and evidence of permits/approvals.</li>
          <li>WETT inspection for any solid-fuel appliances and proof of chimney compliance.</li>
          <li>Fuel tank (propane/oil) compliance and transfer of any rental agreements.</li>
          <li>Zoning/Use & MDS verification for intended uses (livestock, shop, second unit, STRs).</li>
          <li>Conservation Authority review for any planned improvements (additions, driveways, docks).</li>
          <li>Survey provision or allowance for staking; title search free of encumbrances affecting use.</li>
          <li>Access & Road Maintenance Agreement review where applicable; confirmation of year-round access.</li>
          <li>HST clause specifying whether HST is included in or in addition to the purchase price.</li>
          <li>Inclusions/exclusions for outbuildings, equipment, and rentals (propane tanks, water heaters, softeners).</li>
        </ol>
        <br/>
        Review the <a href="/SK/transaction-checklists" rel="noopener noreferrer">Transaction Checklists</a>
        to match conditions to your client’s goals and the property’s characteristics.
        `,
      },
    ],
  },
  {
    type: "transaction topic",
    id: "cooperative",
    title: "Co-operative Residential Homes",
    description: `<p>
      Purchasing in a residential housing co-operative (“co-op”) is different from buying freehold or a condominium.
      Instead of owning real property, buyers typically purchase shares in a corporation and receive the
      right to occupy a specific unit under an Occupancy Agreement.
      <br/><br/>
      Note that non-profit/community housing co-ops generally do not involve a market purchase or resale;
      they allocate units to approved members and charge housing charges rather than a purchase price. This guide focuses on
      equity or market co-ops where share interests are bought and sold.
      <br/><br/>
      Each co-op sets its own by-laws, membership approval process, rules, and financial practices. REALTORS® should perform
      thorough due diligence, collaborate with an experienced lawyer familiar with co-ops, and align guidance with client goals.
    </p>`,
    text: [
      {
        title: "Common Due Diligences",
        text: `
        Review the Single Family Residential (Resale) section, as many of those 
        considerations will apply to this scenario as well. 
        Here are some extra things to consider specifically when it comes to 
        co-operative residential homes.
        <br/><br/>
        <strong>Ownership Structure & Documents</strong><br/>
        Confirm the buyer is acquiring shares (and any related membership certificate) plus an Occupancy Agreement granting the right to occupy a specific unit.
        Understand how assignments/transfers are handled and any transfer fees.
        <br/><strong class="bold">Action:</strong> Request the full co-op 
        information package, similar to a condo status certificate outlining 
        current budget, reserve/contingency policies, building insurance 
        certificate, by-laws/rules, Occupancy Agreement form, board policies 
        (subletting, pets, renovations, smoking), and recent board minutes.
        <br/><br/>
  
        <strong>Board Approval & Membership</strong><br/>
        Most co-ops require board consent and a membership interview/application (often including references, income/credit checks, and agreement to rules).
        <br/><strong class="bold">Action:</strong> Clarify approval timelines, required documentation, and any non-refundable application/transfer fees. Build these into your condition dates.
        <br/><br/>
  
        <strong>Monthly Fees & What They Cover</strong><br/>
        Charges often include the co-op’s building mortgage payment, property taxes, building insurance, common utilities, maintenance, and reserves; unit-level utilities may be separate.
        <br/><strong class="bold">Action:</strong> Obtain a fee breakdown, history of increases, any scheduled adjustments, and recent/anticipated special assessments.
        <br/><br/>
  
        <strong>Financial Health of the Co-op</strong><br/>
        Similar to a condo, this will typically be done by the lawyer. Review audited statements, debt 
        load (blanket/building mortgage), maturity dates, interest rate exposure, 
        reserve levels, and arrears.
        <br/><strong class="bold">Action:</strong> Ask for the most recent audited 
        financials, current budget, arrears/collections policy, and any 
        engineering/building condition reports.
        <br/><br/>
  
        <strong>Building Condition & Plans</strong><br/>
        Evaluate age/condition of roof, elevators, boilers/HVAC, windows, 
        parking/garage, balconies, and life-safety systems.
        <br/><strong class="bold">Action:</strong> Seek capital plan summaries and 
        recent/ongoing projects. Consider a home inspector for the unit and 
        common-element awareness.
        <br/><br/>
  
        <strong>Use, Renovations & Subletting</strong><br/>
        Co-ops usually restrict rentals and require written consent for sublets 
        and renovations. Some have rules on flooring, pets, BBQs, and smoking.
        <br/><strong class="bold">Action:</strong> Confirm your client’s intended 
        use (e.g., work-from-home, short-term hosting, pets) is permitted. Obtain 
        written policies and any required renovation approval process.
        <br/><br/>
  
        <strong>Title, Encumbrances & Legal Review</strong><br/>
        The corporation owns the real property; members hold shares. Lenders to the 
        co-op may have a blanket mortgage with covenants affecting operations.
        <br/><strong class="bold">Action:</strong> Buyer’s lawyer should review: 
        corporate title, any blanket mortgages/charges, ground lease(s) if 
        land-lease, compliance with by-laws, and whether lenders provide 
        non-disturbance/recognition agreements protecting members’ occupancy rights.
        <br/><br/>
  
        <strong>Insurance</strong><br/>
        The co-op insures the building; members typically insure contents, 
        improvements, and personal liability.
        <br/><strong class="bold">Action:</strong> Obtain the building’s insurance 
        certificate and limits. Have the buyer secure appropriate unit insurance 
        early; confirm any insurance requirements in the Occupancy Agreement.
        <br/><br/>
  
        <strong>Taxes & HST</strong><br/>
        Property taxes are commonly paid by the corporation (funded via monthly 
        charges). HST/Land Transfer Tax treatment can vary based on structure and 
        circumstances.
        <br/><strong class="bold">Action:</strong> Have the buyer’s lawyer/accountant confirm tax treatment (including any HST/LTT considerations) and ensure the offer clearly states whether HST is included or in addition, if applicable.
        `,
      },
      {
        title: "Financing & Appraisal",
        text: `
        <strong>Financing Availability</strong><br/>
        Conventional mortgages on title are not typical for co-ops. Some lenders/credit unions offer share-secured loans or co-op financing products with specific underwriting (board approval, assignment/pledge of shares, recognition agreements).
        <br/><strong class="bold">Action:</strong> Engage knowledgeable lenders early; provide the co-op’s documents up front. Prepare backup options if lender choice is limited.
        <br/><br/>
  
        <strong>Down Payment & Terms</strong><br/>
        Requirements may differ from condo/freehold norms and can vary by lender and co-op policy.
        <br/><strong class="bold">Action:</strong> Confirm minimum down payment, amortization limits, and any lender conditions tied to the co-op’s financials or building mortgage maturity.
        <br/><br/>
  
        <strong>Appraisal Considerations</strong><br/>
        Appraisers may use comparable co-op or condo sales but will account for differences (transferability, financing constraints, fees, building condition).
        <br/><br/>
  
        <strong>Insurance & Lender Security</strong><br/>
        Lenders often require assignment/pledge of shares and a recognition/non-disturbance agreement from the co-op.
        <br/><strong class="bold">Action:</strong> Coordinate early between lender, buyer’s lawyer, and the co-op to satisfy document and timing requirements.
        <br/><br/>
  
       <strong>Deposit Amount</strong><br/>
      Deposits for resale homes typically range from 5-10% of the purchase price.
      <br/><strong class="bold">Action:</strong> Discuss a deposit strategy with your 
      client, factoring in local market competitiveness.<br/>
      
        `,
      },
      {
        title: "Additional Common Questions",
        text: `
        <ol>
          <li>What is the board’s approval process, timeline, and criteria?</li>
          <li>What do monthly housing charges include, and what increases are anticipated?</li>
          <li>Are there any planned special assessments or major capital projects?</li>
          <li>What is the status of the co-op’s building mortgage (rate, maturity, covenants)?</li>
          <li>Are there arrears issues among members, and how are they handled?</li>
          <li>What are the policies on pets, smoking, subletting, and renovations?</li>
          <li>Is parking/storage included or assigned, and how are allocations managed?</li>
          <li>Are there transfer fees, right-of-first-refusal provisions, or waiting lists?</li>
          <li>What insurance coverage does the co-op carry, and what must the member carry?</li>
          <li>Are there any legal disputes or regulatory compliance issues disclosed?</li>
          <li>How does the co-op handle accessibility upgrades and accommodation requests?</li>
        </ol>
        `,
      },
      {
        title: "Offer Practices & Conditions/Clauses",
        text: `
        <strong>Offer Best Practices</strong><br/> <ol> <li>"Time is of the essence" when it comes to agreements. Make sure that agreements and related deal documents are signed within their designated time frames.</li> <li>Confirm that all OREA forms and clauses used are both current and appropriate for the specific deal.</li> <li>Check the MLS Listing for any supplemental documents to be included with the offer.</li> <li>Deposit delivery must occur within the specified time frame on the agreement. If the deposit isn't delivered, the client is in breach and may face legal action. </li> <li>Always assign a firm date to conditions and clauses. Phrases like "5 business days" can cause confusion and conflict. A set deadline makes expectations clear for everyone involved.</li> </ol>
        <br/>
  
        <strong>Conditions & Clauses</strong><br/>
      If a client chooses to not include a condition in their offer, it is important 
      to ensure they understand the risks and are comfortable with the potential 
      consequences. Furthermore, ensure you complete FORM 127 for situations where 
      your clients choose to not include a recommended condition in the offer.
      <br/><br/>
      It is always best practice to include a Buyer's Lawyer Review condition in 
      the offer, especially if the property has unique characteristics that 
      require further investigation.
      <br/><br/>
      Review the <a
      href="/SK/transaction-checklists"
      rel="noopener noreferrer"
    >
      Transaction Checklists</a> section to view & better understand common 
      conditions and how they may apply to your client's specific needs for this 
      type of transaction.<br/><br/>
        `,
      },
    ],
  },
  {
    type: "transaction topic",
    id: "powerofsale",
    title: "Foreclosures (Power of Sale)",
    description: `<p>
      A Power of Sale (POS) occurs when a lender or mortgagee sells a property after a borrower defaults,
      using a contractual right in the mortgage. Unlike foreclosure, POS is typically a non-court process
      and the Seller (often a lender, mortgage insurer, or bank's lawyer) makes 
      very limited representations and warranties.
      Most POS properties are sold strictly “as is, where is,” with the seller
      relying on a mandatory Schedule of terms.
      <br/><br/>
      These transactions require extra diligence around title, possession, 
      condition, insurance, and timing.
      Client goals (primary residence, flip, rental, land value) should be 
      clarified early and revisited as new information emerges. 
      Always involve a lawyer experienced with POS sales.
    </p>`,
    text: [
      {
        title: "Common Due Diligences",
        text: `
        <strong>Seller Schedule & Limited Warranties</strong><br/>
        Lender/insurer Sellers typically provide a Schedule B overriding many standard terms (no representations,
        no warranties, no knowledge of condition, chattels/fixtures not warranted, 
        Buyer assumes risk).
        <br/><strong class="bold">Action:</strong> Obtain and review the full 
        Schedule before drafting the offer.
        Highlight any clauses about vacant possession, extensions, cancellation rights, and utility activation/hold harmless.
        <br/><br/>

          <strong>Original Owner's Right to Redeem</strong><br/>
      Prior to completion, the original owner typically has rights to reinstate or 
      redeem the mortgage, which can halt or cancel the POS sale—even after 
      acceptance—until closing is completed and title is transferred. A quicker 
      closing timeline is recommended in order to mitigate this risk.
      <br/><strong class="bold">Action:</strong> Notify the buyer in writing at the 
      outset and again upon acceptance that the sale may not complete if the original 
      owner exercises these rights. 
      <br/><br/>
  
        <strong>Property Condition & Access</strong><br/>
        POS homes may be vacant, winterized, or occupied; utilities may be off; Seller often refuses repairs.
        Inspections can be limited and “power-on” tests may require waivers/indemnities.
        <br/><strong class="bold">Action:</strong> Arrange a qualified inspection (and specialty inspections if needed).
        Confirm whether utilities can be safely activated for testing and who bears responsibility/costs.
        <br/><br/>
  
        <strong>Occupancy, Tenancies & Possession</strong><br/>
        Vacant possession is not guaranteed unless expressly provided. If occupied (owner or tenant),
        lawful termination/eviction after closing may fall to the Buyer.
        <br/><strong class="bold">Action:</strong> Determine current occupancy status. If vacant possession is essential,
        seek explicit wording or plan timelines/costs for post-closing possession with legal counsel.
        <br/><br/>
        
        <strong>Title, Arrears & Encumbrances</strong><br/>
        Expect the Seller to convey title subject to standard exceptions; they may know little about prior issues.
        Outstanding taxes, condo arrears, or executions must be identified and handled through the title search/adjustments.
        <br/><strong class="bold">Action:</strong> Order a comprehensive title search (GeoWarehouse, lawyer’s search).
        Obtain tax certificate/condo status (if applicable) and confirm how arrears will be adjusted/discharged on closing.
        Consider title insurance endorsements suited to POS risks.
        <br/><br/>
  
        <strong>Status Certificate (If Applicable)</strong><br/>
        Lender-Sellers generally will not obtain a status certificate.
        <br/><strong class="bold">Action:</strong> Make your offer conditional on 
        the Buyer obtaining and reviewing a current status certificate.
        <br/><br/>
  
        <strong>Environmental & Safety</strong><br/>
        Unknowns can include former grow-ops, water damage, mold, fuel tanks, or code issues.
        <br/><strong class="bold">Action:</strong> Ask for any known reports; consider environmental or WETT inspections,
        sewer scope, or air quality/radon testing as warranted by age/condition and client tolerance.
        <br/><br/>
  
        <strong>Utilities & Insurance</strong><br/>
        Vacant or distressed properties can be harder to insure. Solid-fuel appliances, older wiring/plumbing,
        or significant deferred maintenance may trigger coverage limits or higher premiums.
        <br/><strong class="bold">Action:</strong> Encourage clients to secure an insurance quote early. If power/water must
        be activated for testing, coordinate safe procedures and indemnities 
        required by the Seller.
        <br/><br/>
  
        <strong>Timing, Extensions & Redemption Risk</strong><br/>
        Schedules often allow the Seller to extend closing or impose strict deposit/irrevocable timelines.
        In some cases, mortgagors may reinstate/redeem prior to closing—review the 
        Seller’s rights.
        <br/><strong class="bold">Action:</strong> Read the provided Schedule for extension/cancellation provisions. Build realistic
        condition and closing periods and prepare clients for bank-lawyer timelines.
        `,
      },
      {
        title: "Financing & Appraisal",
        text: `
        <strong>Financing Reality</strong><br/>
        Lenders underwrite “as is” condition; significant defects, missing kitchens/baths, or utility shutoffs can
        impair mortgageability.
        <br/><strong class="bold">Action:</strong> Engage a mortgage professional early; disclose POS nature and property
        condition. Line up backup financing if the home is borderline habitable.
        <br/><br/>
  
        <strong>Appraisal Constraints</strong><br/>
        Appraisers may assign limited value to unfinished/unsafe areas and may require utilities to be on.
        <br/><strong class="bold">Action:</strong> Provide access/logistics for appraisal promptly after acceptance.
        Share any available reports/photos; clarify what is included/excluded (chattels often excluded).
        <br/><br/>
  
        <strong>Deposit Amount</strong><br/>
      Deposits commonly fall in the 5–10% range of the purchase price, but may be 
      shaped by market conditions and co-op timelines.
      <br/><strong class="bold">Action:</strong> Align deposit timing with board-approval and financing-condition dates.
      `,
      },
      {
        title: "Additional Common Questions",
        text: `
        <ol>
          <li>Will the seller warrant vacant possession? (Usually no—confirm in writing if offered.)</li>
          <li>Can utilities be turned on for inspection/appraisal? Who is liable if something goes wrong?</li>
          <li>What exactly does the provided Schedule change vs the standard OREA agreement?</li>
          <li>Are there tax/condo arrears or executions to be cleared on closing?</li>
          <li>What are the insurance implications of vacancy/condition?</li>
          <li>If it's a condo, who obtains and pays for the status certificate?</li>
          <li>Could the Seller extend closing? Under what conditions?</li>
          <li>Are there municipal work orders or permits outstanding?</li>
          <li>What are typical timelines to obtain possession if the property is occupied post-closing?</li>
        </ol>
        `,
      },
      {
        title: "Offer Practices & Conditions/Clauses",
        text: `
       <strong>Offer Best Practices</strong><br/>
      <ol>
      <li>"Time is of the essence" when it comes to agreements. Make sure that 
      agreements and related deal documents are signed within their designated 
      time frames.</li>
      <li>Confirm that all OREA forms and clauses used are both current and 
      appropriate for the specific deal.</li>
      <li>Check the MLS Listing for any supplemental documents to be included with 
      the offer.</li>
      <li>Deposit delivery must occur within the specified time frame on the agreement. 
      If the deposit isn't delivered, the client is in breach and may face legal 
      action. </li>
      <li>Always assign a firm date to conditions and clauses. Phrases like "5 
      business days" can cause confusion and conflict. A set deadline makes 
      expectations clear for everyone involved.</li>
      </ol>

      <br/>
      <strong>Conditions & Clauses</strong><br/>
      If a client chooses to not include a condition in their offer, it is important 
      to ensure they understand the risks and are comfortable with the potential 
      consequences. Furthermore, ensure you complete FORM 127 for situations where 
      your clients choose to not include a recommended condition in the offer.
      <br/><br/>
      It is always best practice to include a Buyer's Lawyer Review condition in 
      the offer so that the Buyer can discuss the additional risks associated with 
      this type of transaction, especially if the property has unique characteristics that 
      require further investigation.
      <br/><br/>
      Review the <a
      href="/SK/transaction-checklists"
      rel="noopener noreferrer"
    >
      Transaction Checklists</a> section to view & better understand common 
      conditions and how they may apply to your client's specific needs for this 
      type of transaction.<br/><br/>
      `,
      },
    ],
  },
];

export default transactionTopics;
